/* EDIT: products, priority handles, media, productPolicy and rotationRanking.
Rotation uses currently available products outside First Flight. The prominent product shelf uses the approved selection data; the shorter tracker remains a separate reference.
Keep credentials and raw visitor/session data out of this public file. */
window.LF_CONTENT = {
  "version": "2026-10-02-seven-product-interest-draft",
  "store": "https://lonelyfloater.com",
  "currency": "USD",
  "loaderMs": 1100,
  "session": {
    "loader": "lf-home-intro-v2",
    "gateway": "lf-home-entry-v2",
    "cart": "lf-draft-cart-v1"
  },
  "cursor": {
    "enabled": true,
    "asset": null,
    "size": 32
  },
  "selections": {
    "priorities": [
      "fs23-dad-hat",
      "fs23-ribbed-knit-beanie"
    ],
    "aveek": [
      "dad-hat-2",
      "aveek-toxic-by-nature-short-sleeve-t-shirt",
      "aveek-toxic-by-nature-crop-hoodie",
      "aveek-toxic-by-nature-women-s-heavyweight-boxy-tee"
    ],
    "travis": [
      "travis-michael-x-lonely-floater-punky-family-business-dad-hat",
      "dad-hat-1",
      "travis-michael-x-lonely-floater-family-business-unisex-hoodie",
      "travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie"
    ],
    "lunar": [
      "the-lfx-coast-2-coast-cuffed-beanie",
      "earth-print-bandana",
      "lonely-floater-lunar-return-dad-hat",
      "forgotten-vision-bucket",
      "coast-2-coast-trucker"
    ]
  },
  "products": [
    {
      "handle": "fs23-dad-hat",
      "title": "FS23 Dad hat",
      "displayTitle": "FS23 Dad Hat",
      "url": "https://lonelyfloater.com/products/fs23-dad-hat",
      "image": "assets/fs23-dad-hat.webp",
      "imageAlt": "Black dad hat featuring a red balloon embroidered on the front, side view.",
      "variants": [
        {
          "id": 44372281557280,
          "title": "Black",
          "price": 30.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-front-6a596433e39c9.png?v=1784243267",
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 44372281622816,
          "title": "Cranberry",
          "price": 30.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-front-6a596433e558c.png?v=1784243267",
          "option1": "Cranberry",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/fs23-dad-hat.js"
      },
      "id": 8087557472544,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 30.5,
      "priceMin": 30.5,
      "priceMax": 30.5,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-front-6a596433e39c9.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-right-front-6a596433e4d0a.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-left-front-6a596433e4f52.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-back-6a596433e50e7.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-left-side-6a596433e520c.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-right-side-6a596433e533c.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-front-6a596433e558c.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-right-front-6a596433e583c.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-left-front-6a596433e5aa4.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-back-6a596433e5df3.png?v=1784243267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-left-side-6a596433e5fdd.png?v=1784243268",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-cranberry-right-side-6a596433e61df.png?v=1784243267"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Cranberry"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fs23-dad-hat.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "fs23-ribbed-knit-beanie",
      "title": "FS23 Ribbed knit beanie",
      "displayTitle": "FS23 Ribbed Knit Beanie",
      "url": "https://lonelyfloater.com/products/fs23-ribbed-knit-beanie",
      "image": "assets/fs23-ribbed-knit-beanie.webp",
      "imageAlt": "FS23 Ribbed knit beanie",
      "variants": [
        {
          "id": 44372505788704,
          "title": "Default Title",
          "price": 33.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/ribbed-knit-beanie-black-front-6428cd75b48f2.png?v=1680395644",
          "option1": "Default Title",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/fs23-ribbed-knit-beanie.js"
      },
      "id": 8087594631456,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 33.99,
      "priceMin": 33.99,
      "priceMax": 33.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/ribbed-knit-beanie-black-front-6428cd75b48f2.png?v=1680395644"
      ],
      "options": [
        {
          "name": "Title",
          "position": 1,
          "values": [
            "Default Title"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fs23-ribbed-knit-beanie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "dad-hat-2",
      "title": "Aveek Toxic by Nature Dad hat",
      "displayTitle": "Toxic by Nature Dad Hat",
      "url": "https://lonelyfloater.com/products/dad-hat-2",
      "image": "assets/dad-hat-2.webp",
      "imageAlt": "Black dad hat featuring a colorful \"AVEEK AVM\" logo with a gradient design, front view.",
      "variants": [
        {
          "id": 50353942626592,
          "title": "Black",
          "price": 31,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-front-685e140e35dae.png?v=1750995998",
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 50353942659360,
          "title": "Navy",
          "price": 31,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-front-685e140e37ac4.png?v=1750995998",
          "option1": "Navy",
          "option2": null,
          "option3": null
        },
        {
          "id": 50353942692128,
          "title": "White",
          "price": 31,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-front-685e140e3a75a.png?v=1750995998",
          "option1": "White",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:35.549Z",
        "sales": null
      },
      "id": 9986270888224,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 31,
      "priceMin": 31,
      "priceMax": 31,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-front-685e140e35dae.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-right-side-685e140e36a60.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-right-front-685e140e36e11.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-left-side-685e140e370d9.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-left-front-685e140e3737d.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-black-back-685e140e3761f.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-front-685e140e37ac4.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-right-side-685e140e380d7.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-right-front-685e140e388b8.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-left-side-685e140e38fdb.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-left-front-685e140e396a6.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-navy-back-685e140e39d7c.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-front-685e140e3a75a.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-right-side-685e140e3ae1c.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-right-front-685e140e3b49c.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-left-side-685e140e3ba3b.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-left-front-685e140e3bfb2.png?v=1750995998",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/classic-dad-hat-white-back-685e140e3c59f.png?v=1750995998"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "White"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/dad-hat-2.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "aveek-toxic-by-nature-short-sleeve-t-shirt",
      "title": "Aveek Toxic By Nature Short Sleeve T-shirt",
      "displayTitle": "Toxic by Nature Tee",
      "url": "https://lonelyfloater.com/products/aveek-toxic-by-nature-short-sleeve-t-shirt",
      "image": "assets/aveek-toxic-by-nature-short-sleeve-t-shirt.webp",
      "imageAlt": "Black short sleeve t-shirt featuring colorful \"TOXIC BY NATURE\" text and lips graphic on the back, back view.",
      "variants": [
        {
          "id": 50354051186976,
          "title": "XS",
          "price": 48,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "XS",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354051219744,
          "title": "S",
          "price": 48,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354051252512,
          "title": "M",
          "price": 48,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "M",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354051285280,
          "title": "L",
          "price": 48,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "L",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354051318048,
          "title": "XL",
          "price": 48,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354051350816,
          "title": "2XL",
          "price": 50,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "2XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354051383584,
          "title": "3XL",
          "price": 52,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
          "option1": "3XL",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:37.106Z",
        "sales": null
      },
      "id": 9986316304672,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 48,
      "priceMin": 48,
      "priceMax": 52,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-back-685e1a09e1e9f.png?v=1750997524",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/mens-fitted-t-shirt-black-front-685e1a09e2dd0.png?v=1750997524"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/aveek-toxic-by-nature-short-sleeve-t-shirt.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "aveek-toxic-by-nature-crop-hoodie",
      "title": "Aveek Toxic by Nature Crop Hoodie",
      "displayTitle": "Toxic by Nature Crop Hoodie",
      "url": "https://lonelyfloater.com/products/aveek-toxic-by-nature-crop-hoodie",
      "image": "assets/aveek-toxic-by-nature-crop-hoodie.webp",
      "imageAlt": "Black crop hoodie featuring \"TOXIC BY NATURE\" text in vibrant colors and a lips graphic on the back, back view.",
      "variants": [
        {
          "id": 50354270437664,
          "title": "Black / S",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-back-685e259ae7c45.png?v=1751000490",
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 50354270470432,
          "title": "Black / M",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-back-685e259ae7c45.png?v=1751000490",
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 50354270503200,
          "title": "Black / L",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-back-685e259ae7c45.png?v=1751000490",
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 50354270535968,
          "title": "Black / XL",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-back-685e259ae7c45.png?v=1751000490",
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 50354270568736,
          "title": "Black / 2XL",
          "price": 55.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-back-685e259ae7c45.png?v=1751000490",
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 50354270601504,
          "title": "Military Green / S",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-back-685e259ae97be.png?v=1751000491",
          "option1": "Military Green",
          "option2": "S",
          "option3": null
        },
        {
          "id": 50354270634272,
          "title": "Military Green / M",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-back-685e259ae97be.png?v=1751000491",
          "option1": "Military Green",
          "option2": "M",
          "option3": null
        },
        {
          "id": 50354270667040,
          "title": "Military Green / L",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-back-685e259ae97be.png?v=1751000491",
          "option1": "Military Green",
          "option2": "L",
          "option3": null
        },
        {
          "id": 50354270699808,
          "title": "Military Green / XL",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-back-685e259ae97be.png?v=1751000491",
          "option1": "Military Green",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 50354270732576,
          "title": "Military Green / 2XL",
          "price": 55.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-back-685e259ae97be.png?v=1751000491",
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 50354270765344,
          "title": "Storm / S",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-back-685e259aea2d2.png?v=1751000491",
          "option1": "Storm",
          "option2": "S",
          "option3": null
        },
        {
          "id": 50354270798112,
          "title": "Storm / M",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-back-685e259aea2d2.png?v=1751000491",
          "option1": "Storm",
          "option2": "M",
          "option3": null
        },
        {
          "id": 50354270830880,
          "title": "Storm / L",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-back-685e259aea2d2.png?v=1751000491",
          "option1": "Storm",
          "option2": "L",
          "option3": null
        },
        {
          "id": 50354270863648,
          "title": "Storm / XL",
          "price": 53.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-back-685e259aea2d2.png?v=1751000491",
          "option1": "Storm",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 50354270896416,
          "title": "Storm / 2XL",
          "price": 55.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-back-685e259aea2d2.png?v=1751000491",
          "option1": "Storm",
          "option2": "2XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/aveek-toxic-by-nature-crop-hoodie.js"
      },
      "id": 9986411200800,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 53.5,
      "priceMin": 53.5,
      "priceMax": 55.5,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-back-685e259ae7c45.png?v=1751000490",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-black-front-685e259ae8f87.png?v=1751000491",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-front-685e259ae93c1.png?v=1751000491",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-military-green-back-685e259ae97be.png?v=1751000491",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-front-685e259ae9cdc.png?v=1751000491",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-cropped-hoodie-storm-back-685e259aea2d2.png?v=1751000491"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Military Green",
            "Storm"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/aveek-toxic-by-nature-crop-hoodie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "aveek-toxic-by-nature-women-s-heavyweight-boxy-tee",
      "title": "Aveek Toxic by Nature Women’s heavyweight boxy tee",
      "displayTitle": "Toxic by Nature Boxy Tee",
      "url": "https://lonelyfloater.com/products/aveek-toxic-by-nature-women-s-heavyweight-boxy-tee",
      "image": "assets/aveek-toxic-by-nature-women-s-heavyweight-boxy-tee.webp",
      "imageAlt": "Black heavyweight boxy tee featuring red \"TOXIC BY NATURE\" text on the left chest, front view.",
      "variants": [
        {
          "id": 50354297798944,
          "title": "S",
          "price": 29,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-front-685e26a8b5474.png?v=1751000755",
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354297831712,
          "title": "M",
          "price": 29,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-front-685e26a8b5474.png?v=1751000755",
          "option1": "M",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354297864480,
          "title": "L",
          "price": 29,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-front-685e26a8b5474.png?v=1751000755",
          "option1": "L",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354297897248,
          "title": "XL",
          "price": 29,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-front-685e26a8b5474.png?v=1751000755",
          "option1": "XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 50354297930016,
          "title": "2XL",
          "price": 31,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-front-685e26a8b5474.png?v=1751000755",
          "option1": "2XL",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:39.792Z",
        "sales": null
      },
      "id": 9986426339616,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 29,
      "priceMin": 29,
      "priceMax": 31,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-front-685e26a8b5474.png?v=1751000755",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-back-685e26a8b6297.png?v=1751000755",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-left-685e26a8b644d.png?v=1751000755",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/womens-heavyweight-boxy-t-shirt-black-right-685e26a8b65e2.png?v=1751000755"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/aveek-toxic-by-nature-women-s-heavyweight-boxy-tee.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "travis-michael-x-lonely-floater-punky-family-business-dad-hat",
      "title": "Travis Michael x Lonely Floater \"Family Business\" Punky  Dad hat",
      "displayTitle": "Family Business / Punky Dad Hat",
      "url": "https://lonelyfloater.com/products/travis-michael-x-lonely-floater-punky-family-business-dad-hat",
      "image": "assets/travis-michael-x-lonely-floater-punky-family-business-dad-hat.webp",
      "imageAlt": "Black dad hat featuring a yellow embroidered spider logo on the front, side view.",
      "variants": [
        {
          "id": 39480651546727,
          "title": "Black",
          "price": 30,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-front-61aad1617d497.png?v=1638584684",
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 39480651579495,
          "title": "Cranberry",
          "price": 30,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-cranberry-front-61aad1617ddfd.png?v=1638584693",
          "option1": "Cranberry",
          "option2": null,
          "option3": null
        },
        {
          "id": 39480651612263,
          "title": "Khaki",
          "price": 30,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-khaki-front-61aad1617e69d.png?v=1638584701",
          "option1": "Khaki",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:41.271Z",
        "sales": null
      },
      "id": 6592821690471,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 30,
      "priceMin": 30,
      "priceMax": 30,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-front-61aad1617d497.png?v=1638584684",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-right-front-61aad1617d859.png?v=1638584686",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-left-front-61aad1617d997.png?v=1638584688",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-back-61aad1617daf7.png?v=1638584689",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-right-side-61aad1617dc55.png?v=1638584691",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-cranberry-front-61aad1617ddfd.png?v=1638584693",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-cranberry-right-front-61aad1617dfde.png?v=1638584694",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-cranberry-left-front-61aad1617e17d.png?v=1638584696",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-cranberry-back-61aad1617e33c.png?v=1638584697",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-cranberry-right-side-61aad1617e4df.png?v=1638584699",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-khaki-front-61aad1617e69d.png?v=1638584701",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-khaki-right-front-61aad1617e891.png?v=1638584702",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-khaki-left-front-61aad1617ea50.png?v=1638584704",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-khaki-back-61aad1617ec22.png?v=1638584706",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-khaki-right-side-61aad1617ee17.png?v=1638584707"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Cranberry",
            "Khaki"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/travis-michael-x-lonely-floater-punky-family-business-dad-hat.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "dad-hat-1",
      "title": "Travis Michael x Lonely Floater \"Family Business\"  FS Dad Hat",
      "displayTitle": "Family Business / FS Dad Hat",
      "url": "https://lonelyfloater.com/products/dad-hat-1",
      "image": "assets/dad-hat-1.webp",
      "imageAlt": "Black dad hat featuring colorful embroidered \"TM\" logo with crossed bones and \"XX\" on the front, side view.",
      "variants": [
        {
          "id": 39518995677287,
          "title": "Black",
          "price": 31.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-front-61b1850b7faaa.png?v=1639023888",
          "option1": "Black",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:41.437Z",
        "sales": null
      },
      "id": 6602957619303,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 31.5,
      "priceMin": 31.5,
      "priceMax": 31.5,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-front-61b1850b7faaa.png?v=1639023888",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-right-front-61b1850b7fc97.png?v=1639023889",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-left-front-61b1850b7fdef.png?v=1639023891",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-right-side-61b1850b7ff78.png?v=1639023893"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/dad-hat-1.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "travis-michael-x-lonely-floater-family-business-unisex-hoodie",
      "title": "Travis Michael x Lonely Floater \"Family Business\" Kanj Unisex Hoodie",
      "displayTitle": "Family Business / Kanj Hoodie",
      "url": "https://lonelyfloater.com/products/travis-michael-x-lonely-floater-family-business-unisex-hoodie",
      "image": "assets/travis-michael-x-lonely-floater-family-business-unisex-hoodie.webp",
      "imageAlt": "Black unisex hoodie featuring a large circular graphic with \"Lonely Floater\" and playful tongue design on the back, back view.",
      "variants": [
        {
          "id": 39480654823527,
          "title": "Black / S",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-back-61b185395d280.png?v=1639023937",
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39480654856295,
          "title": "Black / M",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-back-61b185395d280.png?v=1639023937",
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39480654889063,
          "title": "Black / L",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-back-61b185395d280.png?v=1639023937",
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39480654921831,
          "title": "Black / XL",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-back-61b185395d280.png?v=1639023937",
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39480654954599,
          "title": "Black / 2XL",
          "price": 52,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-back-61b185395d280.png?v=1639023937",
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39480654987367,
          "title": "Maroon / S",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-back-61b1853961aed.png?v=1639023942",
          "option1": "Maroon",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39480655020135,
          "title": "Maroon / M",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-back-61b1853961aed.png?v=1639023942",
          "option1": "Maroon",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39480655052903,
          "title": "Maroon / L",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-back-61b1853961aed.png?v=1639023942",
          "option1": "Maroon",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39480655085671,
          "title": "Maroon / XL",
          "price": 49.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-back-61b1853961aed.png?v=1639023942",
          "option1": "Maroon",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39480655118439,
          "title": "Maroon / 2XL",
          "price": 52,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-back-61b1853961aed.png?v=1639023942",
          "option1": "Maroon",
          "option2": "2XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:41.635Z",
        "sales": null
      },
      "id": 6592823296103,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 49.5,
      "priceMin": 49.5,
      "priceMax": 52,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-back-61b185395d280.png?v=1639023937",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-61b185395f20c.png?v=1639023939",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-front-61b185396052e.png?v=1639023941",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-maroon-back-61b1853961aed.png?v=1639023942"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Maroon"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/travis-michael-x-lonely-floater-family-business-unisex-hoodie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie",
      "title": "Travis Michael x Lonely Floater \"Family Business\"  Camo Splash Unisex Hoodie",
      "displayTitle": "Family Business / Camo Splash Hoodie",
      "url": "https://lonelyfloater.com/products/travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie",
      "image": "assets/travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie.webp",
      "imageAlt": "Camo splash unisex hoodie in purple with multicolor camouflage pattern, front view, featuring \"LNYC\" logo on chest.",
      "variants": [
        {
          "id": 39510083960935,
          "title": "XS",
          "price": 66,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "XS",
          "option2": null,
          "option3": null
        },
        {
          "id": 39510083993703,
          "title": "S",
          "price": 66,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 39510084026471,
          "title": "M",
          "price": 66,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "M",
          "option2": null,
          "option3": null
        },
        {
          "id": 39510084059239,
          "title": "L",
          "price": 66,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "L",
          "option2": null,
          "option3": null
        },
        {
          "id": 39510084092007,
          "title": "XL",
          "price": 66,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 39510084124775,
          "title": "2XL",
          "price": 68,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "2XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 39510084157543,
          "title": "3XL",
          "price": 68,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
          "option1": "3XL",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:41.797Z",
        "sales": null
      },
      "id": 6600484651111,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 66,
      "priceMin": 66,
      "priceMax": 68,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-front-616f608b92fc6.png?v=1634689173",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-unisex-hoodie-white-back-616f608b931d9.png?v=1634689175"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "the-lfx-coast-2-coast-cuffed-beanie",
      "title": "The \"LFX\" Coast 2 Coast Cuffed Beanie",
      "displayTitle": "The \"LFX\" Coast 2 Coast Cuffed Beanie",
      "url": "https://lonelyfloater.com/products/the-lfx-coast-2-coast-cuffed-beanie",
      "image": "assets/the-lfx-coast-2-coast-cuffed-beanie.webp",
      "imageAlt": "Gold cuffed beanie with green \"Lonely Floater\" logo on the front, front view, plain background.",
      "variants": [
        {
          "id": 43643694219552,
          "title": "Black",
          "price": 33.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/cuffed-beanie-black-front-6358193ec0841.png?v=1666718017",
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 43643694252320,
          "title": "Brown",
          "price": 33.99,
          "available": true,
          "image": null,
          "option1": "Brown",
          "option2": null,
          "option3": null
        },
        {
          "id": 43643694285088,
          "title": "Spruce",
          "price": 33.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/cuffed-beanie-spruce-front-63581975f1c7f.png?v=1666718073",
          "option1": "Spruce",
          "option2": null,
          "option3": null
        },
        {
          "id": 43643694317856,
          "title": "Gold",
          "price": 33.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/cuffed-beanie-gold-front-635818ab0b7fb.png?v=1666717870",
          "option1": "Gold",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:41.997Z",
        "sales": null
      },
      "id": 7964034236704,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 33.99,
      "priceMin": 33.99,
      "priceMax": 33.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/cuffed-beanie-gold-front-635818ab0b7fb.png?v=1666717870",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/the--lfx--coast-2-coast-cuffed-beanie-transparent-2.png?v=1778226804",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/the--lfx--coast-2-coast-cuffed-beanie-transparent-3.png?v=1778226813",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/cuffed-beanie-black-front-6358193ec0841.png?v=1666718017",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/cuffed-beanie-spruce-front-63581975f1c7f.png?v=1666718073"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Brown",
            "Spruce",
            "Gold"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/the-lfx-coast-2-coast-cuffed-beanie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "earth-print-bandana",
      "title": "Ether Monogram Print Bandana",
      "displayTitle": "Ether Monogram Print Bandana",
      "url": "https://lonelyfloater.com/products/earth-print-bandana",
      "image": "assets/earth-print-bandana.webp",
      "imageAlt": "Black bandana featuring a subtle ether monogram print in a repeating pattern, flat lay view.",
      "variants": [
        {
          "id": 39895216914535,
          "title": "S",
          "price": 36.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-bandana-white-s-front-6336280cdd0ee.png?v=1664493592",
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 39895216947303,
          "title": "M",
          "price": 36.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-bandana-white-m-front-6336280ce295c.png?v=1664493594",
          "option1": "M",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:42.152Z",
        "sales": null
      },
      "id": 6703093317735,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 36.99,
      "priceMin": 36.99,
      "priceMax": 36.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-bandana-white-s-front-6336280cdd0ee.png?v=1664493592",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-bandana-white-m-front-6336280ce295c.png?v=1664493594"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "S",
            "M"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/earth-print-bandana.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "lonely-floater-lunar-return-dad-hat",
      "title": "Lonely Floater Lunar Return Dad Hat",
      "displayTitle": "Lonely Floater Lunar Return Dad Hat",
      "url": "https://lonelyfloater.com/products/lonely-floater-lunar-return-dad-hat",
      "image": "assets/lonely-floater-lunar-return-dad-hat.webp",
      "imageAlt": "Black dad hat featuring \"Lonely Floater\" in silver embroidered text on the front, front view.",
      "variants": [
        {
          "id": 39900629434471,
          "title": "Black",
          "price": 33.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-front-6344df18abc05.png?v=1665457956",
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 39900629467239,
          "title": "Spruce",
          "price": 33.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-spruce-front-6344df18aea96.png?v=1665457964",
          "option1": "Spruce",
          "option2": null,
          "option3": null
        },
        {
          "id": 39900629500007,
          "title": "Khaki",
          "price": 33.99,
          "available": true,
          "image": null,
          "option1": "Khaki",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:42.309Z",
        "sales": null
      },
      "id": 6703020933223,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 33.99,
      "priceMin": 33.99,
      "priceMax": 33.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-front-6344df18abc05.png?v=1665457956",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-right-front-6344df18ae683.png?v=1665457958",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-left-front-6344df18ae7fd.png?v=1665457960",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-black-right-side-6344df18ae992.png?v=1665457962",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-spruce-front-6344df18aea96.png?v=1665457964",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-spruce-right-front-6344df18aec44.png?v=1665457966",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-spruce-left-front-6344df18aedbd.png?v=1665457967",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/classic-dad-hat-spruce-right-side-6344df18aeee2.png?v=1665457969",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/lonely-floater-lunar-return-dad-hat-transparent-9.png?v=1778224279",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/lonely-floater-lunar-return-dad-hat-transparent-10.png?v=1778224287",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/lonely-floater-lunar-return-dad-hat-transparent-11.png?v=1778224296",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/lonely-floater-lunar-return-dad-hat-transparent-12.png?v=1778224304"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Spruce",
            "Khaki"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/lonely-floater-lunar-return-dad-hat.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "forgotten-vision-bucket",
      "title": "Forgotten Secret Bucket",
      "displayTitle": "Forgotten Secret Bucket",
      "url": "https://lonelyfloater.com/products/forgotten-vision-bucket",
      "image": "assets/forgotten-vision-bucket.webp",
      "imageAlt": "Dill green bucket hat with white \"Lonely Floater\" logo on front, top view on a white background.",
      "variants": [
        {
          "id": 39895156818023,
          "title": "Black",
          "price": 30,
          "available": false,
          "image": null,
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 39895156850791,
          "title": "Dill",
          "price": 30,
          "available": true,
          "image": null,
          "option1": "Dill",
          "option2": null,
          "option3": null
        },
        {
          "id": 39895156883559,
          "title": "Slate Blue",
          "price": 30,
          "available": true,
          "image": null,
          "option1": "Slate Blue",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/forgotten-vision-bucket.js"
      },
      "id": 6703065792615,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 30,
      "priceMin": 30,
      "priceMax": 30,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-bucket-transparent-1.png?v=1778200296",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-bucket-transparent-2.png?v=1778200303",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-bucket-transparent-3.png?v=1778200310"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Dill",
            "Slate Blue"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/forgotten-vision-bucket.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "coast-2-coast-trucker",
      "title": "\"LFX\" Coast 2 Coast Trucker",
      "displayTitle": "\"LFX\" Coast 2 Coast Trucker",
      "url": "https://lonelyfloater.com/products/coast-2-coast-trucker",
      "image": "assets/coast-2-coast-trucker.webp",
      "imageAlt": "Caramel trucker hat with white \"Lonely Floater\" logo and \"LfxLA\" text on front, side view, plain background.",
      "variants": [
        {
          "id": 39898596999271,
          "title": "Black",
          "price": 32,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-black-front-6333b08da3cf6.png?v=1664493932",
          "option1": "Black",
          "option2": null,
          "option3": null
        },
        {
          "id": 39898597032039,
          "title": "Navy",
          "price": 32,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-navy-front-6333b08da72dc.png?v=1664493932",
          "option1": "Navy",
          "option2": null,
          "option3": null
        },
        {
          "id": 39902107533415,
          "title": "Caramel",
          "price": 32,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-caramel-front-6336291802080.png?v=1664493932",
          "option1": "Caramel",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:42.586Z",
        "sales": null
      },
      "id": 6703068938343,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 32,
      "priceMin": 32,
      "priceMax": 32,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-caramel-front-6336291802080.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-caramel-right-front-63362918050e0.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-caramel-back-6336291805188.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-black-front-6333b08da3cf6.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-black-right-front-6333b08da7109.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-black-back-6333b08da7220.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-navy-front-6333b08da72dc.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-navy-right-front-6333b08da7391.png?v=1664493932",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/closed-back-trucker-cap-navy-back-6333b08da744e.png?v=1664493932"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "Caramel"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/coast-2-coast-trucker.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "camo-floater-raglan-tee",
      "title": "Camo Floater Raglan Tee",
      "displayTitle": "Camo Floater Raglan Tee",
      "url": "https://lonelyfloater.com/products/camo-floater-raglan-tee",
      "image": "assets/camo-floater-raglan-tee.webp",
      "imageAlt": "Camo Floater Raglan Tee freeshipping - Lonely Floater",
      "variants": [
        {
          "id": 35506144003,
          "title": "Small",
          "price": 27.99,
          "available": true,
          "image": null,
          "option1": "Small",
          "option2": null,
          "option3": null
        },
        {
          "id": 35506144067,
          "title": "Medium",
          "price": 27.99,
          "available": true,
          "image": null,
          "option1": "Medium",
          "option2": null,
          "option3": null
        },
        {
          "id": 35506144131,
          "title": "Large",
          "price": 27.99,
          "available": true,
          "image": null,
          "option1": "Large",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-01T23:53:43.383Z",
        "sales": {
          "netItemsSold": 29,
          "periodStart": "2015-01-01",
          "periodEnd": "2026-10-01",
          "source": "Connected Shopify sales query"
        }
      },
      "id": 9706989571,
      "vendor": "LFxNYC",
      "available": true,
      "price": 27.99,
      "priceMin": 27.99,
      "priceMax": 27.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/camo-floater-raglan-tee-transparent-1.png?v=1778198657",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/camo-floater-raglan-tee-transparent-2.png?v=1778198668",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/camo-floater-raglan-tee-transparent-3.png?v=1778198679"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "Small",
            "Medium",
            "Large"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/camo-floater-raglan-tee.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "travel-bugs-unisex-fleece-sweatpants",
      "title": "Travel Bugs Unisex fleece sweatpants (BOTTOM)",
      "displayTitle": "Travel Bugs Fleece Sweatpants",
      "url": "https://lonelyfloater.com/products/travel-bugs-unisex-fleece-sweatpants",
      "image": "assets/interest-travel-bugs-unisex-fleece-sweatpants.webp",
      "imageAlt": "Travel Bugs Unisex fleece sweatpants (BOTTOM)",
      "variants": [
        {
          "id": 39661656572007,
          "title": "XS",
          "price": 41,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
          "option1": "XS",
          "option2": null,
          "option3": null
        },
        {
          "id": 39661656604775,
          "title": "S",
          "price": 41,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 39661656637543,
          "title": "M",
          "price": 41,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
          "option1": "M",
          "option2": null,
          "option3": null
        },
        {
          "id": 39661656670311,
          "title": "L",
          "price": 41,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
          "option1": "L",
          "option2": null,
          "option3": null
        },
        {
          "id": 39661656703079,
          "title": "XL",
          "price": 41,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
          "option1": "XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 39661656735847,
          "title": "2XL",
          "price": 44,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
          "option1": "2XL",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/travel-bugs-unisex-fleece-sweatpants.js"
      },
      "id": 6648748671079,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 41,
      "priceMin": 41,
      "priceMax": 44,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-622fad359845c.png?v=1647291706",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-zoomed-in-622fad3598549.png?v=1647291708"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/travel-bugs-unisex-fleece-sweatpants.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "for-tee",
      "title": "FOR T-Shirt",
      "displayTitle": "FOR Tee",
      "url": "https://lonelyfloater.com/products/for-tee",
      "image": "assets/interest-for-tee.webp",
      "imageAlt": "FOR T-Shirt",
      "variants": [
        {
          "id": 8253207937127,
          "title": "Forest / S",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "S",
          "option3": null
        },
        {
          "id": 8253207969895,
          "title": "Forest / M",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "M",
          "option3": null
        },
        {
          "id": 8253208002663,
          "title": "Forest / L",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "L",
          "option3": null
        },
        {
          "id": 8253208035431,
          "title": "Forest / XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 8253208068199,
          "title": "Forest / 2XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 8253208100967,
          "title": "Forest / 3XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 8253208133735,
          "title": "Forest / 4XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 8253208166503,
          "title": "Red / S",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "S",
          "option3": null
        },
        {
          "id": 8253208199271,
          "title": "Red / M",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "M",
          "option3": null
        },
        {
          "id": 8253208232039,
          "title": "Red / L",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "L",
          "option3": null
        },
        {
          "id": 8253208264807,
          "title": "Red / XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 8253208297575,
          "title": "Red / 2XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 8253208330343,
          "title": "Red / 3XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 8253208363111,
          "title": "Red / 4XL",
          "price": 31.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "4XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/for-tee.js"
      },
      "id": 767854674023,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 31.99,
      "priceMin": 31.99,
      "priceMax": 31.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/for-t-shirt-transparent-1.png?v=1778200267",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/for-t-shirt-transparent-2.png?v=1778200274"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Forest",
            "Red"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/for-tee.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "fs-embroidered-t-shirt",
      "title": "FS Embroidered T-Shirt",
      "displayTitle": "FS Embroidered T-Shirt",
      "url": "https://lonelyfloater.com/products/fs-embroidered-t-shirt",
      "image": "assets/ranked-fs-embroidered-t-shirt-ef5fbac619.webp",
      "imageAlt": "FS Embroidered T-Shirt",
      "variants": [
        {
          "id": 39900536340583,
          "title": "Black / XS",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39900536373351,
          "title": "Black / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900536406119,
          "title": "Black / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900536438887,
          "title": "Black / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900536471655,
          "title": "Black / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900536504423,
          "title": "Black / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900536537191,
          "title": "Black / 3XL",
          "price": 37,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39900536569959,
          "title": "Black / 4XL",
          "price": 39,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39900536602727,
          "title": "Black / 5XL",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "Black",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 39900536635495,
          "title": "Navy / XS",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39900536668263,
          "title": "Navy / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900536701031,
          "title": "Navy / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900536733799,
          "title": "Navy / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900536766567,
          "title": "Navy / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900536799335,
          "title": "Navy / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900536832103,
          "title": "Navy / 3XL",
          "price": 37,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39900536864871,
          "title": "Navy / 4XL",
          "price": 39,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39900536897639,
          "title": "Navy / 5XL",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "Navy",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 39900536930407,
          "title": "Brown / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Brown",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900536963175,
          "title": "Brown / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Brown",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900536995943,
          "title": "Brown / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Brown",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900537028711,
          "title": "Brown / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Brown",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900537061479,
          "title": "Brown / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Brown",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900537094247,
          "title": "Forest / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900537127015,
          "title": "Forest / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900537159783,
          "title": "Forest / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900537225319,
          "title": "Forest / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900537258087,
          "title": "Forest / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900537290855,
          "title": "Forest / 3XL",
          "price": 37,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39900537323623,
          "title": "Forest / 4XL",
          "price": 39,
          "available": true,
          "image": null,
          "option1": "Forest",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39900537356391,
          "title": "Army / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900537389159,
          "title": "Army / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900537421927,
          "title": "Army / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900537454695,
          "title": "Army / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900537487463,
          "title": "Army / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900537520231,
          "title": "Army / 3XL",
          "price": 37,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39900537552999,
          "title": "Army / 4XL",
          "price": 39,
          "available": true,
          "image": null,
          "option1": "Army",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39900537585767,
          "title": "Olive / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Olive",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900537618535,
          "title": "Olive / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Olive",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900537651303,
          "title": "Olive / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Olive",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900537684071,
          "title": "Olive / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Olive",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900537716839,
          "title": "Olive / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Olive",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900537749607,
          "title": "Autumn / S",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Autumn",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900537782375,
          "title": "Autumn / M",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Autumn",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900537815143,
          "title": "Autumn / L",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Autumn",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900537847911,
          "title": "Autumn / XL",
          "price": 33,
          "available": true,
          "image": null,
          "option1": "Autumn",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900537880679,
          "title": "Autumn / 2XL",
          "price": 35,
          "available": true,
          "image": null,
          "option1": "Autumn",
          "option2": "2XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/fs-embroidered-t-shirt.js"
      },
      "id": 6646643654759,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 33,
      "priceMin": 33,
      "priceMax": 41,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-1.png?v=1778221769",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-2.png?v=1778221778",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-3.png?v=1778221787",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-4.png?v=1778221796",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-5.png?v=1778221805",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-6.png?v=1778221814",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-7.png?v=1778221823",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-8.png?v=1778221832",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-9.png?v=1778221842",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-10.png?v=1778221851",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-11.png?v=1778221861",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-12.png?v=1778221869",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-13.png?v=1778221878",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-t-shirt-transparent-14.png?v=1778221886"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "Brown",
            "Forest",
            "Army",
            "Olive",
            "Autumn"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fs-embroidered-t-shirt.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "vision-quest-unisex-fleece-sweatpants",
      "title": "Forgotten Secret 2.0 Set Bottom  Unisex sweatpants",
      "displayTitle": "Forgotten Secret 2.0 Set Bottom  Unisex sweatpants",
      "url": "https://lonelyfloater.com/products/vision-quest-unisex-fleece-sweatpants",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
      "imageAlt": "Forgotten Secret 2.0 Set Bottom  Unisex sweatpants",
      "variants": [
        {
          "id": 39657241411687,
          "title": "Black / XS",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
          "option1": "Black",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39657241444455,
          "title": "Carbon Grey / XS",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
          "option1": "Carbon Grey",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39657241477223,
          "title": "Navy Blazer / XS",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
          "option1": "Navy Blazer",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39657241509991,
          "title": "Carbon Grey / S",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
          "option1": "Carbon Grey",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39657241542759,
          "title": "Navy Blazer / S",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
          "option1": "Navy Blazer",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39657241575527,
          "title": "Black / S",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39657241608295,
          "title": "Black / M",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39657241641063,
          "title": "Carbon Grey / M",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
          "option1": "Carbon Grey",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39657241673831,
          "title": "Navy Blazer / M",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
          "option1": "Navy Blazer",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39657241706599,
          "title": "Carbon Grey / L",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
          "option1": "Carbon Grey",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39657241739367,
          "title": "Navy Blazer / L",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
          "option1": "Navy Blazer",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39657241772135,
          "title": "Black / L",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39657241804903,
          "title": "Navy Blazer / XL",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
          "option1": "Navy Blazer",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39657241837671,
          "title": "Black / XL",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39657241870439,
          "title": "Carbon Grey / XL",
          "price": 40,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
          "option1": "Carbon Grey",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39657241903207,
          "title": "Navy Blazer / 2XL",
          "price": 43,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
          "option1": "Navy Blazer",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39657241935975,
          "title": "Black / 2XL",
          "price": 43,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39657241968743,
          "title": "Carbon Grey / 2XL",
          "price": 43,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
          "option1": "Carbon Grey",
          "option2": "2XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/vision-quest-unisex-fleece-sweatpants.js"
      },
      "id": 6647755210855,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 40,
      "priceMin": 40,
      "priceMax": 43,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-front-63350d9ef1829.png?v=1664421289",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-black-zoomed-in-63350d9f0005f.png?v=1664421291",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-front-63350d9f00155.png?v=1664421293",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-navy-blazer-zoomed-in-63350d9f001fc.png?v=1664421295",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-front-63350d9f002b2.png?v=1664421297",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-fleece-sweatpants-carbon-grey-zoomed-in-63350d9f00364.png?v=1664421299"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Carbon Grey",
            "Navy Blazer"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/vision-quest-unisex-fleece-sweatpants.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "lonely-floater-x-travis-michael-duffle-bag",
      "title": "Travis Michael x Lonely Floater \"FAMILY BUSINESS - PUNKY\"  Camo Splash Duffy",
      "displayTitle": "Family Business / Camo Duffy",
      "url": "https://lonelyfloater.com/products/lonely-floater-x-travis-michael-duffle-bag",
      "image": "assets/interest-lonely-floater-x-travis-michael-duffle-bag.webp",
      "imageAlt": "Travis Michael x Lonely Floater \"FAMILY BUSINESS - PUNKY\"  Camo Splash Duffy",
      "variants": [
        {
          "id": 39516226486375,
          "title": "Default Title",
          "price": 77,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-front-61b185f4cc60f.png?v=1639024129",
          "option1": "Default Title",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/lonely-floater-x-travis-michael-duffle-bag.js"
      },
      "id": 6601950462055,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 77,
      "priceMin": 77,
      "priceMax": 77,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/travis-michael-x-lonely-floater--family-business---punky---camo-splash-duffy-transparent-1.png?v=1778227091",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-back-61788706c0cdb.png?v=1635288846",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-back-6178874ccfbac.png?v=1635288937",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-back-6178cb66de946.png?v=1635306352",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-front-61b185f4cc60f.png?v=1639024129",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-right-front-61b185f4ccf06.png?v=1639024131",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-left-front-61b185f4cd06e.png?v=1639024133",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-back-61b185f4cd23c.png?v=1639024134",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-right-side-61b185f4cd3ad.png?v=1639024136",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-left-side-61b185f4cd4e6.png?v=1639024138",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-top-61b185f4cd60f.png?v=1639024139",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/all-over-print-duffle-bag-white-bottom-61b185f4cd754.png?v=1639024141",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/travis-michael-x-lonely-floater--family-business---punky---camo-splash-duffy-transparent-13.png?v=1778227105"
      ],
      "options": [
        {
          "name": "Title",
          "position": 1,
          "values": [
            "Default Title"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/lonely-floater-x-travis-michael-duffle-bag.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "dream-big-unisex-t-shirt",
      "title": "Forgotten Secret Dream Big Unisex Tee",
      "displayTitle": "Forgotten Secret Dream Big Unisex Tee",
      "url": "https://lonelyfloater.com/products/dream-big-unisex-t-shirt",
      "image": "assets/ranked-dream-big-unisex-t-shirt-68e83e9b99.webp",
      "imageAlt": "Forgotten Secret Dream Big Unisex Tee",
      "variants": [
        {
          "id": 39898571145319,
          "title": "Black Heather / XS",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39898571178087,
          "title": "Black Heather / S",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39898571210855,
          "title": "Black Heather / M",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39898571243623,
          "title": "Black Heather / L",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39898571276391,
          "title": "Black Heather / XL",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39898571309159,
          "title": "Black Heather / 2XL",
          "price": 32.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39898571341927,
          "title": "Black Heather / 3XL",
          "price": 34.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39898571374695,
          "title": "Black Heather / 4XL",
          "price": 36.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39898571407463,
          "title": "Black Heather / 5XL",
          "price": 38.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410",
          "option1": "Black Heather",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 39898571440231,
          "title": "Soft Cream / XS",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39898571472999,
          "title": "Soft Cream / S",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39898571505767,
          "title": "Soft Cream / M",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39898571538535,
          "title": "Soft Cream / L",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39898571571303,
          "title": "Soft Cream / XL",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39898571604071,
          "title": "Soft Cream / 2XL",
          "price": 32.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39898571636839,
          "title": "Soft Cream / 3XL",
          "price": 34.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39898571669607,
          "title": "Soft Cream / 4XL",
          "price": 36.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
          "option1": "Soft Cream",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39898571702375,
          "title": "White / XS",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 39898571735143,
          "title": "White / S",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39898571767911,
          "title": "White / M",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39898571800679,
          "title": "White / L",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39898571833447,
          "title": "White / XL",
          "price": 30.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39898571866215,
          "title": "White / 2XL",
          "price": 32.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39898571898983,
          "title": "White / 3XL",
          "price": 34.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39898571931751,
          "title": "White / 4XL",
          "price": 36.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39898571964519,
          "title": "White / 5XL",
          "price": 38.04,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
          "option1": "White",
          "option2": "5XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/dream-big-unisex-t-shirt.js"
      },
      "id": 6703709683815,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 30.04,
      "priceMin": 30.04,
      "priceMax": 38.04,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-front-63449e2971e28.png?v=1665441410",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-soft-cream-back-63449e296fbad.png?v=1665441410",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-front-63449e2974370.png?v=1665441410",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-white-back-63449e29677e1.png?v=1665441410",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-front-63449e296e266.png?v=1665441410",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-staple-t-shirt-black-heather-back-63449e296cad4.png?v=1665441410"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black Heather",
            "Soft Cream",
            "White"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/dream-big-unisex-t-shirt.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "balance-sweatshirt",
      "title": "Balance  Sweatshirt",
      "displayTitle": "Balance  Sweatshirt",
      "url": "https://lonelyfloater.com/products/balance-sweatshirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/balance--sweatshirt-transparent-1.png?v=1778198382",
      "imageAlt": "Balance  Sweatshirt",
      "variants": [
        {
          "id": 5132432015391,
          "title": "Ash / S",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Ash",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5132432048159,
          "title": "Red / S",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5132432080927,
          "title": "White / S",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5132432113695,
          "title": "Forest Green / S",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5132432146463,
          "title": "Ash / M",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Ash",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5132432179231,
          "title": "Red / M",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5132432211999,
          "title": "White / M",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5132432244767,
          "title": "Forest Green / M",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5132432277535,
          "title": "Ash / L",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Ash",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5132432310303,
          "title": "Red / L",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5132432343071,
          "title": "White / L",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5132432375839,
          "title": "Forest Green / L",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5132432408607,
          "title": "Ash / XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Ash",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5132432441375,
          "title": "Red / XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5132432474143,
          "title": "White / XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5132432506911,
          "title": "Forest Green / XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5132432539679,
          "title": "Ash / 2XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Ash",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5132432572447,
          "title": "Red / 2XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5132432605215,
          "title": "White / 2XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5132432637983,
          "title": "Forest Green / 2XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5132432670751,
          "title": "Ash / 3XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Ash",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 5132432703519,
          "title": "Red / 3XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 5132432736287,
          "title": "White / 3XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 5132432769055,
          "title": "Forest Green / 3XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 5132432801823,
          "title": "Red / 4XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 5132432834591,
          "title": "White / 4XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 5132432867359,
          "title": "Forest Green / 4XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 5132432900127,
          "title": "Red / 5XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Red",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 5132432932895,
          "title": "White / 5XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 5132432965663,
          "title": "Forest Green / 5XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Forest Green",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 5132432998431,
          "title": "Royal / S",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5132433031199,
          "title": "Royal / M",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5132433063967,
          "title": "Royal / L",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5132433096735,
          "title": "Royal / XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5132433129503,
          "title": "Royal / 2XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5132433162271,
          "title": "Royal / 3XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 5132433195039,
          "title": "Royal / 4XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 5132433227807,
          "title": "Royal / 5XL",
          "price": 23.99,
          "available": true,
          "image": null,
          "option1": "Royal",
          "option2": "5XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/balance-sweatshirt.js"
      },
      "id": 385965096991,
      "vendor": "Printify",
      "available": true,
      "price": 23.99,
      "priceMin": 23.99,
      "priceMax": 23.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/balance--sweatshirt-transparent-1.png?v=1778198382",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/balance--sweatshirt-transparent-2.png?v=1778204069",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/balance--sweatshirt-transparent-3.png?v=1778198392",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/balance--sweatshirt-transparent-4.png?v=1778198400",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/balance--sweatshirt-transparent-5.png?v=1778198407"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Ash",
            "Red",
            "White",
            "Forest Green",
            "Royal"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/balance-sweatshirt.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "lonely-floater-lux-hoodie",
      "title": "LONELY FLOATER \"FS LUX\" hoodie",
      "displayTitle": "LONELY FLOATER \"FS LUX\" hoodie",
      "url": "https://lonelyfloater.com/products/lonely-floater-lux-hoodie",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
      "imageAlt": "LONELY FLOATER \"FS LUX\" hoodie",
      "variants": [
        {
          "id": 43643599683872,
          "title": "Pigment Black / S",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
          "option1": "Pigment Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 43643599716640,
          "title": "Pigment Black / M",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
          "option1": "Pigment Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 43643599782176,
          "title": "Pigment Black / L",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
          "option1": "Pigment Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 43643599814944,
          "title": "Pigment Black / XL",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
          "option1": "Pigment Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 43643599847712,
          "title": "Pigment Black / 2XL",
          "price": 57.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
          "option1": "Pigment Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 43643599880480,
          "title": "Pigment Black / 3XL",
          "price": 60,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
          "option1": "Pigment Black",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 43643599913248,
          "title": "Pigment Alpine Green / S",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
          "option1": "Pigment Alpine Green",
          "option2": "S",
          "option3": null
        },
        {
          "id": 43643599946016,
          "title": "Pigment Alpine Green / M",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
          "option1": "Pigment Alpine Green",
          "option2": "M",
          "option3": null
        },
        {
          "id": 43643599978784,
          "title": "Pigment Alpine Green / L",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
          "option1": "Pigment Alpine Green",
          "option2": "L",
          "option3": null
        },
        {
          "id": 43643600011552,
          "title": "Pigment Alpine Green / XL",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
          "option1": "Pigment Alpine Green",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 43643600044320,
          "title": "Pigment Alpine Green / 2XL",
          "price": 57.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
          "option1": "Pigment Alpine Green",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 43643600077088,
          "title": "Pigment Alpine Green / 3XL",
          "price": 60,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
          "option1": "Pigment Alpine Green",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 43643600109856,
          "title": "Pigment Maroon / S",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
          "option1": "Pigment Maroon",
          "option2": "S",
          "option3": null
        },
        {
          "id": 43643600142624,
          "title": "Pigment Maroon / M",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
          "option1": "Pigment Maroon",
          "option2": "M",
          "option3": null
        },
        {
          "id": 43643600175392,
          "title": "Pigment Maroon / L",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
          "option1": "Pigment Maroon",
          "option2": "L",
          "option3": null
        },
        {
          "id": 43643600208160,
          "title": "Pigment Maroon / XL",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
          "option1": "Pigment Maroon",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 43643600240928,
          "title": "Pigment Maroon / 2XL",
          "price": 57.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
          "option1": "Pigment Maroon",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 43643600273696,
          "title": "Pigment Maroon / 3XL",
          "price": 60,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
          "option1": "Pigment Maroon",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 43643600339232,
          "title": "Pigment Slate Blue / S",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973",
          "option1": "Pigment Slate Blue",
          "option2": "S",
          "option3": null
        },
        {
          "id": 43643600372000,
          "title": "Pigment Slate Blue / M",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973",
          "option1": "Pigment Slate Blue",
          "option2": "M",
          "option3": null
        },
        {
          "id": 43643600404768,
          "title": "Pigment Slate Blue / L",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973",
          "option1": "Pigment Slate Blue",
          "option2": "L",
          "option3": null
        },
        {
          "id": 43643600437536,
          "title": "Pigment Slate Blue / XL",
          "price": 55,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973",
          "option1": "Pigment Slate Blue",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 43643600470304,
          "title": "Pigment Slate Blue / 2XL",
          "price": 57.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973",
          "option1": "Pigment Slate Blue",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 43643600503072,
          "title": "Pigment Slate Blue / 3XL",
          "price": 60,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973",
          "option1": "Pigment Slate Blue",
          "option2": "3XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/lonely-floater-lux-hoodie.js"
      },
      "id": 7964011888928,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 55,
      "priceMin": 55,
      "priceMax": 60,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-front-6355e28e3848f.png?v=1666572953",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-back-6355e28e392cc.png?v=1666572956",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-black-front-6355e28e39465.png?v=1666572958",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-alpine-green-back-6355e28e39665.png?v=1666572962",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-back-6355e28e399d2.png?v=1666572964",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-maroon-front-6355e28e39d47.png?v=1666572966",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-back-6355e28e3a0a1.png?v=1666572970",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-pigment-dyed-hoodie-pigment-slate-blue-front-6355e28e3a48e.png?v=1666572973"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Pigment Black",
            "Pigment Alpine Green",
            "Pigment Maroon",
            "Pigment Slate Blue"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/lonely-floater-lux-hoodie.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "fire-red-t-shirt",
      "title": "Fire Red  T-shirt",
      "displayTitle": "Fire Red  T-shirt",
      "url": "https://lonelyfloater.com/products/fire-red-t-shirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
      "imageAlt": "Fire Red  T-shirt",
      "variants": [
        {
          "id": 32375611621479,
          "title": "XS",
          "price": 47,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
          "option1": "XS",
          "option2": null,
          "option3": null
        },
        {
          "id": 32375611654247,
          "title": "S",
          "price": 47,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 32375611687015,
          "title": "M",
          "price": 47,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
          "option1": "M",
          "option2": null,
          "option3": null
        },
        {
          "id": 32375611719783,
          "title": "L",
          "price": 47,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
          "option1": "L",
          "option2": null,
          "option3": null
        },
        {
          "id": 32375611752551,
          "title": "XL",
          "price": 48.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
          "option1": "XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 32375611785319,
          "title": "2XL",
          "price": 50.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
          "option1": "2XL",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/fire-red-t-shirt.js"
      },
      "id": 4591926706279,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 47,
      "priceMin": 47,
      "priceMax": 50.5,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-d68e2289.png?v=1611040720",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-4c69d1ce.png?v=1611040720"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fire-red-t-shirt.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "womens-focus-bear-hoodie",
      "title": "Women's Focus Bear  Hoodie",
      "displayTitle": "Women's Focus Bear  Hoodie",
      "url": "https://lonelyfloater.com/products/womens-focus-bear-hoodie",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-1.png?v=1778228283",
      "imageAlt": "Women's Focus Bear  Hoodie",
      "variants": [
        {
          "id": 5124459429919,
          "title": "Arctic White / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Arctic White",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459462687,
          "title": "Bottle Green / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Bottle Green",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459495455,
          "title": "Hawaiian Blue / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hawaiian Blue",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459528223,
          "title": "Hot Pink / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hot Pink",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459560991,
          "title": "New French Navy / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "New French Navy",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459593759,
          "title": "Orange Crush / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Orange Crush",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459626527,
          "title": "Purple / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Purple",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459659295,
          "title": "Sun Yellow / XS",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Sun Yellow",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 5124459692063,
          "title": "Arctic White / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Arctic White",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459724831,
          "title": "Bottle Green / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Bottle Green",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459757599,
          "title": "Hawaiian Blue / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hawaiian Blue",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459790367,
          "title": "Hot Pink / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hot Pink",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459823135,
          "title": "New French Navy / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "New French Navy",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459855903,
          "title": "Orange Crush / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Orange Crush",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459888671,
          "title": "Purple / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Purple",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459921439,
          "title": "Sun Yellow / S",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Sun Yellow",
          "option2": "S",
          "option3": null
        },
        {
          "id": 5124459954207,
          "title": "Arctic White / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Arctic White",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124459986975,
          "title": "Bottle Green / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Bottle Green",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460019743,
          "title": "Hawaiian Blue / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hawaiian Blue",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460052511,
          "title": "Hot Pink / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hot Pink",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460085279,
          "title": "New French Navy / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "New French Navy",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460118047,
          "title": "Orange Crush / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Orange Crush",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460150815,
          "title": "Purple / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Purple",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460183583,
          "title": "Sun Yellow / M",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Sun Yellow",
          "option2": "M",
          "option3": null
        },
        {
          "id": 5124460216351,
          "title": "Arctic White / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Arctic White",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460249119,
          "title": "Bottle Green / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Bottle Green",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460281887,
          "title": "Hawaiian Blue / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hawaiian Blue",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460314655,
          "title": "Hot Pink / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hot Pink",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460347423,
          "title": "New French Navy / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "New French Navy",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460380191,
          "title": "Orange Crush / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Orange Crush",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460412959,
          "title": "Purple / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Purple",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460445727,
          "title": "Sun Yellow / L",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Sun Yellow",
          "option2": "L",
          "option3": null
        },
        {
          "id": 5124460478495,
          "title": "Arctic White / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Arctic White",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460511263,
          "title": "Bottle Green / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Bottle Green",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460544031,
          "title": "Hawaiian Blue / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hawaiian Blue",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460576799,
          "title": "Hot Pink / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hot Pink",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460609567,
          "title": "New French Navy / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "New French Navy",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460642335,
          "title": "Orange Crush / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Orange Crush",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460675103,
          "title": "Purple / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Purple",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460707871,
          "title": "Sun Yellow / XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Sun Yellow",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 5124460740639,
          "title": "Arctic White / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Arctic White",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460773407,
          "title": "Bottle Green / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Bottle Green",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460806175,
          "title": "Hawaiian Blue / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hawaiian Blue",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460838943,
          "title": "Hot Pink / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Hot Pink",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460871711,
          "title": "New French Navy / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "New French Navy",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460904479,
          "title": "Orange Crush / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Orange Crush",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460937247,
          "title": "Purple / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Purple",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 5124460970015,
          "title": "Sun Yellow / 2XL",
          "price": 34.99,
          "available": true,
          "image": null,
          "option1": "Sun Yellow",
          "option2": "2XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/womens-focus-bear-hoodie.js"
      },
      "id": 385967030303,
      "vendor": "Printify",
      "available": true,
      "price": 34.99,
      "priceMin": 34.99,
      "priceMax": 34.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-1.png?v=1778228283",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-2.png?v=1778228292",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-3.png?v=1778228300",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-4.png?v=1778228308",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-5.png?v=1778228316",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-6.png?v=1778228325",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-7.png?v=1778228333",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-8.png?v=1778228342",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-9.png?v=1778228349",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-10.png?v=1778228358",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-11.png?v=1778228366",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-12.png?v=1778228374",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-13.png?v=1778228382",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-14.png?v=1778228390",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-15.png?v=1778228397",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/women-s-focus-bear--hoodie-transparent-16.png?v=1778228406"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Arctic White",
            "Bottle Green",
            "Hawaiian Blue",
            "Hot Pink",
            "New French Navy",
            "Orange Crush",
            "Purple",
            "Sun Yellow"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/womens-focus-bear-hoodie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "allevil-short-sleeve-unisex-t-shirt",
      "title": "Money Press Short-Sleeve Unisex T-Shirt",
      "displayTitle": "Money Press Short-Sleeve Unisex T-Shirt",
      "url": "https://lonelyfloater.com/products/allevil-short-sleeve-unisex-t-shirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/money-press-short-sleeve-unisex-t-shirt-transparent-1.png?v=1778224797",
      "imageAlt": "Money Press Short-Sleeve Unisex T-Shirt",
      "variants": [
        {
          "id": 32842642718823,
          "title": "White / XS",
          "price": 40,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 32842642751591,
          "title": "White / S",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "S",
          "option3": null
        },
        {
          "id": 32842642784359,
          "title": "White / M",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "M",
          "option3": null
        },
        {
          "id": 32842642817127,
          "title": "White / L",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "L",
          "option3": null
        },
        {
          "id": 32842642849895,
          "title": "White / XL",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 32842642882663,
          "title": "White / 2XL",
          "price": 43.5,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 32842642915431,
          "title": "White / 3XL",
          "price": 45.5,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 32842642948199,
          "title": "White / 4XL",
          "price": 47.5,
          "available": true,
          "image": null,
          "option1": "White",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 32842642980967,
          "title": "Black Heather / XS",
          "price": 40,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "XS",
          "option3": null
        },
        {
          "id": 32842643013735,
          "title": "Black Heather / S",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "S",
          "option3": null
        },
        {
          "id": 32842643046503,
          "title": "Black Heather / M",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "M",
          "option3": null
        },
        {
          "id": 32842643079271,
          "title": "Black Heather / L",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "L",
          "option3": null
        },
        {
          "id": 32842643112039,
          "title": "Black Heather / XL",
          "price": 41,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 32842643144807,
          "title": "Black Heather / 2XL",
          "price": 43.5,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 32842643177575,
          "title": "Black Heather / 3XL",
          "price": 45.5,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 32842643210343,
          "title": "Black Heather / 4XL",
          "price": 47.5,
          "available": true,
          "image": null,
          "option1": "Black Heather",
          "option2": "4XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/allevil-short-sleeve-unisex-t-shirt.js"
      },
      "id": 4699790704743,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 40,
      "priceMin": 40,
      "priceMax": 47.5,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/money-press-short-sleeve-unisex-t-shirt-transparent-1.png?v=1778224797",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/money-press-short-sleeve-unisex-t-shirt-transparent-2.png?v=1778224805",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/money-press-short-sleeve-unisex-t-shirt-transparent-3.png?v=1778224813"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "White",
            "Black Heather"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/allevil-short-sleeve-unisex-t-shirt.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "long-sleeve-t-shirt",
      "title": "Dom Da Don Data Long Sleeve T",
      "displayTitle": "Dom Da Don Data Long Sleeve T",
      "url": "https://lonelyfloater.com/products/long-sleeve-t-shirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
      "imageAlt": "Dom Da Don Data Long Sleeve T",
      "variants": [
        {
          "id": 19649782317159,
          "title": "Black / S",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 19649782349927,
          "title": "Black / M",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 19649782382695,
          "title": "Black / L",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 19649782415463,
          "title": "Black / XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 19649782448231,
          "title": "Black / 2XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 19649782480999,
          "title": "Black / 3XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 19649782513767,
          "title": "Black / 4XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 19649782546535,
          "title": "Black / 5XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
          "option1": "Black",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 19649782579303,
          "title": "Navy / S",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "S",
          "option3": null
        },
        {
          "id": 19649782612071,
          "title": "Navy / M",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "M",
          "option3": null
        },
        {
          "id": 19649782644839,
          "title": "Navy / L",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "L",
          "option3": null
        },
        {
          "id": 19649782677607,
          "title": "Navy / XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 19649782710375,
          "title": "Navy / 2XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 19649782743143,
          "title": "Navy / 3XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 19649782775911,
          "title": "Navy / 4XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 19649782808679,
          "title": "Navy / 5XL",
          "price": 26,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
          "option1": "Navy",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 19649782841447,
          "title": "Military Green / S",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "S",
          "option3": null
        },
        {
          "id": 19649782874215,
          "title": "Military Green / M",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "M",
          "option3": null
        },
        {
          "id": 19649782906983,
          "title": "Military Green / L",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "L",
          "option3": null
        },
        {
          "id": 19649782939751,
          "title": "Military Green / XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 19649782972519,
          "title": "Military Green / 2XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 19649783005287,
          "title": "Military Green / 3XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 19649783038055,
          "title": "Military Green / 4XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 19649783070823,
          "title": "Military Green / 5XL",
          "price": 28.5,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
          "option1": "Military Green",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 19649783103591,
          "title": "Indigo Blue / S",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "S",
          "option3": null
        },
        {
          "id": 19649783136359,
          "title": "Indigo Blue / M",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "M",
          "option3": null
        },
        {
          "id": 19649783169127,
          "title": "Indigo Blue / L",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "L",
          "option3": null
        },
        {
          "id": 19649783201895,
          "title": "Indigo Blue / XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 19649783234663,
          "title": "Indigo Blue / 2XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 19649783267431,
          "title": "Indigo Blue / 3XL",
          "price": 34.99,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 19649783300199,
          "title": "Indigo Blue / 4XL",
          "price": 26,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 19649783332967,
          "title": "Indigo Blue / 5XL",
          "price": 28.5,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567",
          "option1": "Indigo Blue",
          "option2": "5XL",
          "option3": null
        },
        {
          "id": 19649783365735,
          "title": "Orange / S",
          "price": 25,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "S",
          "option3": null
        },
        {
          "id": 19649783398503,
          "title": "Orange / M",
          "price": 25,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "M",
          "option3": null
        },
        {
          "id": 19649783431271,
          "title": "Orange / L",
          "price": 25,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "L",
          "option3": null
        },
        {
          "id": 19649783464039,
          "title": "Orange / XL",
          "price": 25,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 19649783496807,
          "title": "Orange / 2XL",
          "price": 26,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 19649783529575,
          "title": "Orange / 3XL",
          "price": 26,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 19649783562343,
          "title": "Orange / 4XL",
          "price": 26.5,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 19649783595111,
          "title": "Orange / 5XL",
          "price": 28.5,
          "available": false,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
          "option1": "Orange",
          "option2": "5XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/long-sleeve-t-shirt.js"
      },
      "id": 1962308960359,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 25,
      "priceMin": 25,
      "priceMax": 34.99,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-09924ed9.png?v=1611040567",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-1575c150.png?v=1611040567",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6bee80dd.png?v=1611040567",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-19ffc2ed.png?v=1611040567",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-f977654d.png?v=1611040567"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "Military Green",
            "Indigo Blue",
            "Orange"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/long-sleeve-t-shirt.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "fly-at-your-own-altitude-premium-heavyweight-tee",
      "title": "Fly At Your Own Altitude Premium Heavyweight Tee",
      "displayTitle": "Fly At Your Own Altitude Premium Heavyweight Tee",
      "url": "https://lonelyfloater.com/products/fly-at-your-own-altitude-premium-heavyweight-tee",
      "image": "assets/ranked-fly-at-your-own-altitude-premium-heavyweight-tee-dad3a5ed09.webp",
      "imageAlt": "Fly At Your Own Altitude Premium Heavyweight Tee",
      "variants": [
        {
          "id": 39895177658471,
          "title": "White / S",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39895177691239,
          "title": "White / M",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39895177724007,
          "title": "White / L",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39895177756775,
          "title": "White / XL",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39895177789543,
          "title": "White / 2XL",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39895177822311,
          "title": "White / 3XL",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39895177855079,
          "title": "White / 4XL",
          "price": 32.95,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
          "option1": "White",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39900545351783,
          "title": "Black / S",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900545384551,
          "title": "Black / M",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900545417319,
          "title": "Black / L",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900545450087,
          "title": "Black / XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900545482855,
          "title": "Black / 2XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900545515623,
          "title": "Black / 3XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39900545548391,
          "title": "Black / 4XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
          "option1": "Black",
          "option2": "4XL",
          "option3": null
        },
        {
          "id": 39900545581159,
          "title": "Vintage Gold / S",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "S",
          "option3": null
        },
        {
          "id": 39900545613927,
          "title": "Vintage Gold / M",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "M",
          "option3": null
        },
        {
          "id": 39900545646695,
          "title": "Vintage Gold / L",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "L",
          "option3": null
        },
        {
          "id": 39900545679463,
          "title": "Vintage Gold / XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 39900545712231,
          "title": "Vintage Gold / 2XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 39900545744999,
          "title": "Vintage Gold / 3XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "3XL",
          "option3": null
        },
        {
          "id": 39900545777767,
          "title": "Vintage Gold / 4XL",
          "price": 35.9,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
          "option1": "Vintage Gold",
          "option2": "4XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/fly-at-your-own-altitude-premium-heavyweight-tee.js"
      },
      "id": 6703069462631,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 32.95,
      "priceMin": 32.95,
      "priceMax": 35.9,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-front-6344de60ce91b.png?v=1666761120",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-vintage-gold-back-6344de60cee5d.png?v=1666761120",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-front-6344de60cda43.png?v=1666760882",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-black-back-6344de60ce614.png?v=1666760882",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-front-6344de60cf3ea.png?v=1665457787",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mens-premium-heavyweight-tee-white-back-6344de60cfbf1.png?v=1665457791"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "White",
            "Black",
            "Vintage Gold"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fly-at-your-own-altitude-premium-heavyweight-tee.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "womens-tropicamo-crop-hoodie",
      "title": "Womens' Tropicamo Crop Hoodie",
      "displayTitle": "Womens' Tropicamo Crop Hoodie",
      "url": "https://lonelyfloater.com/products/womens-tropicamo-crop-hoodie",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
      "imageAlt": "Womens' Tropicamo Crop Hoodie",
      "variants": [
        {
          "id": 32828170567783,
          "title": "Black / S",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
          "option1": "Black",
          "option2": "S",
          "option3": null
        },
        {
          "id": 32828170600551,
          "title": "Black / M",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
          "option1": "Black",
          "option2": "M",
          "option3": null
        },
        {
          "id": 32828170633319,
          "title": "Black / L",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
          "option1": "Black",
          "option2": "L",
          "option3": null
        },
        {
          "id": 32828170666087,
          "title": "Black / XL",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
          "option1": "Black",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 32828170698855,
          "title": "Black / 2XL",
          "price": 47,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
          "option1": "Black",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 32828170731623,
          "title": "Military Green / S",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-361c48cb.png?v=1611040788",
          "option1": "Military Green",
          "option2": "S",
          "option3": null
        },
        {
          "id": 32828170764391,
          "title": "Military Green / M",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-361c48cb.png?v=1611040788",
          "option1": "Military Green",
          "option2": "M",
          "option3": null
        },
        {
          "id": 32828170797159,
          "title": "Military Green / L",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-361c48cb.png?v=1611040788",
          "option1": "Military Green",
          "option2": "L",
          "option3": null
        },
        {
          "id": 32828170829927,
          "title": "Military Green / XL",
          "price": 46.5,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-361c48cb.png?v=1611040788",
          "option1": "Military Green",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 32828170862695,
          "title": "Military Green / 2XL",
          "price": 47,
          "available": true,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-361c48cb.png?v=1611040788",
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null
        },
        {
          "id": 32828170895463,
          "title": "Peach / S",
          "price": 46.5,
          "available": false,
          "image": null,
          "option1": "Peach",
          "option2": "S",
          "option3": null
        },
        {
          "id": 32828170928231,
          "title": "Peach / M",
          "price": 46.5,
          "available": false,
          "image": null,
          "option1": "Peach",
          "option2": "M",
          "option3": null
        },
        {
          "id": 32828170960999,
          "title": "Peach / L",
          "price": 46.5,
          "available": false,
          "image": null,
          "option1": "Peach",
          "option2": "L",
          "option3": null
        },
        {
          "id": 32828170993767,
          "title": "Peach / XL",
          "price": 46.5,
          "available": false,
          "image": null,
          "option1": "Peach",
          "option2": "XL",
          "option3": null
        },
        {
          "id": 32828171026535,
          "title": "Peach / 2XL",
          "price": 47,
          "available": false,
          "image": null,
          "option1": "Peach",
          "option2": "2XL",
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/womens-tropicamo-crop-hoodie.js"
      },
      "id": 4694437822567,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 46.5,
      "priceMin": 46.5,
      "priceMax": 47,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-8b43da11.png?v=1611040788",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-361c48cb.png?v=1611040788"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Military Green",
            "Peach"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/womens-tropicamo-crop-hoodie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "dressy-sweats",
      "title": "Dressy Sweats",
      "displayTitle": "Dressy Sweats",
      "url": "https://lonelyfloater.com/products/dressy-sweats",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-535ad524.png?v=1611040670",
      "imageAlt": "Dressy Sweats",
      "variants": [
        {
          "id": 32032913424487,
          "title": "XS",
          "price": 61.5,
          "available": true,
          "image": null,
          "option1": "XS",
          "option2": null,
          "option3": null
        },
        {
          "id": 32032913490023,
          "title": "S",
          "price": 61.5,
          "available": true,
          "image": null,
          "option1": "S",
          "option2": null,
          "option3": null
        },
        {
          "id": 32032913555559,
          "title": "M",
          "price": 61.5,
          "available": true,
          "image": null,
          "option1": "M",
          "option2": null,
          "option3": null
        },
        {
          "id": 32032913621095,
          "title": "L",
          "price": 61.5,
          "available": true,
          "image": null,
          "option1": "L",
          "option2": null,
          "option3": null
        },
        {
          "id": 32032913653863,
          "title": "XL",
          "price": 61.5,
          "available": true,
          "image": null,
          "option1": "XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 32032913686631,
          "title": "2XL",
          "price": 64,
          "available": true,
          "image": null,
          "option1": "2XL",
          "option2": null,
          "option3": null
        },
        {
          "id": 32032913719399,
          "title": "3XL",
          "price": 64,
          "available": true,
          "image": null,
          "option1": "3XL",
          "option2": null,
          "option3": null
        }
      ],
      "source": {
        "verifiedAt": "2026-10-02T00:48:46.809Z",
        "product": "https://lonelyfloater.com/products/dressy-sweats.js"
      },
      "id": 4515960455271,
      "vendor": "Lonely Floater",
      "available": true,
      "price": 61.5,
      "priceMin": 61.5,
      "priceMax": 64,
      "currency": "USD",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-535ad524.png?v=1611040670",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/dressy-sweats-transparent-2.png?v=1778199173",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/dressy-sweats-transparent-3.png?v=1778199180",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/dressy-sweats-transparent-4.png?v=1778199186",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/dressy-sweats-transparent-5.png?v=1778199193"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/dressy-sweats.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "new-bolo",
      "id": 1426574049383,
      "title": "BOLO DOLO T",
      "vendor": "Lonely Floater",
      "available": false,
      "price": 24,
      "priceMin": 24,
      "priceMax": 30,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/new-bolo",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "Orange",
            "Red"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 12649537765479,
          "title": "Black / XS",
          "available": false,
          "price": 29,
          "option1": "Black",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537798247,
          "title": "Black / S",
          "available": false,
          "price": 29,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537831015,
          "title": "Black / M",
          "available": false,
          "price": 29,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537863783,
          "title": "Black / L",
          "available": false,
          "price": 29,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537896551,
          "title": "Black / XL",
          "available": false,
          "price": 29,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537929319,
          "title": "Black / 2XL",
          "available": false,
          "price": 30,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537962087,
          "title": "Black / 3XL",
          "available": false,
          "price": 30,
          "option1": "Black",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-100ec438.png?v=1611040445"
        },
        {
          "id": 12649537994855,
          "title": "Navy / XS",
          "available": false,
          "price": 24,
          "option1": "Navy",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538027623,
          "title": "Navy / S",
          "available": false,
          "price": 24,
          "option1": "Navy",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538060391,
          "title": "Navy / M",
          "available": false,
          "price": 24,
          "option1": "Navy",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538093159,
          "title": "Navy / L",
          "available": false,
          "price": 24,
          "option1": "Navy",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538125927,
          "title": "Navy / XL",
          "available": false,
          "price": 24,
          "option1": "Navy",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538158695,
          "title": "Navy / 2XL",
          "available": false,
          "price": 25,
          "option1": "Navy",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538191463,
          "title": "Navy / 3XL",
          "available": false,
          "price": 25,
          "option1": "Navy",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-94919b39.png?v=1611040445"
        },
        {
          "id": 12649538224231,
          "title": "Orange / XS",
          "available": false,
          "price": 24,
          "option1": "Orange",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538256999,
          "title": "Orange / S",
          "available": false,
          "price": 24,
          "option1": "Orange",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538289767,
          "title": "Orange / M",
          "available": false,
          "price": 24,
          "option1": "Orange",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538322535,
          "title": "Orange / L",
          "available": false,
          "price": 24,
          "option1": "Orange",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538355303,
          "title": "Orange / XL",
          "available": false,
          "price": 24,
          "option1": "Orange",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538388071,
          "title": "Orange / 2XL",
          "available": false,
          "price": 25,
          "option1": "Orange",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538420839,
          "title": "Orange / 3XL",
          "available": false,
          "price": 25,
          "option1": "Orange",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-44554676.png?v=1611040445"
        },
        {
          "id": 12649538453607,
          "title": "Red / XS",
          "available": false,
          "price": 28,
          "option1": "Red",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        },
        {
          "id": 12649538486375,
          "title": "Red / S",
          "available": false,
          "price": 28,
          "option1": "Red",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        },
        {
          "id": 12649538519143,
          "title": "Red / M",
          "available": false,
          "price": 28,
          "option1": "Red",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        },
        {
          "id": 12649538551911,
          "title": "Red / L",
          "available": false,
          "price": 28,
          "option1": "Red",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        },
        {
          "id": 12649538584679,
          "title": "Red / XL",
          "available": false,
          "price": 28,
          "option1": "Red",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        },
        {
          "id": 12649538617447,
          "title": "Red / 2XL",
          "available": false,
          "price": 29,
          "option1": "Red",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        },
        {
          "id": 12649538650215,
          "title": "Red / 3XL",
          "available": false,
          "price": 29,
          "option1": "Red",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-2bd7723d.png?v=1611040445"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/new-bolo.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "forgotten-secret-white-seam-oscuro-beanie-out-for-the-season",
      "id": 9703783299,
      "title": "Forgotten Secret GEN1 BLK Beanie",
      "vendor": "LFxNYC",
      "available": false,
      "price": 25,
      "priceMin": 25,
      "priceMax": 25,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/forgotten-secret-white-seam-oscuro-beanie-out-for-the-season",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-gen1-blk-beanie-transparent-1.png?v=1778200323",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-gen1-blk-beanie-transparent-1.png?v=1778200323",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-gen1-blk-beanie-transparent-2.png?v=1778200329"
      ],
      "options": [
        {
          "name": "Title",
          "position": 1,
          "values": [
            "Default Title"
          ]
        }
      ],
      "variants": [
        {
          "id": 35491684739,
          "title": "Default Title",
          "available": false,
          "price": 25,
          "option1": "Default Title",
          "option2": null,
          "option3": null,
          "image": null
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/forgotten-secret-white-seam-oscuro-beanie-out-for-the-season.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "forgotten-secret-out-for-the-season",
      "id": 9703778563,
      "title": "Forgotten Secret GEN1 Dad Hat",
      "vendor": "LFxNYC",
      "available": false,
      "price": 25,
      "priceMin": 25,
      "priceMax": 30,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/forgotten-secret-out-for-the-season",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-gen1-dad-hat-transparent-1.png?v=1778263711",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-gen1-dad-hat-transparent-1.png?v=1778263711",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/forgotten-secret-gen1-dad-hat-transparent-2.png?v=1778263717"
      ],
      "options": [
        {
          "name": "Style",
          "position": 1,
          "values": [
            "Standard",
            "Distressed"
          ]
        }
      ],
      "variants": [
        {
          "id": 35497955779,
          "title": "Standard",
          "available": false,
          "price": 25,
          "option1": "Standard",
          "option2": null,
          "option3": null,
          "image": null
        },
        {
          "id": 35497958211,
          "title": "Distressed",
          "available": false,
          "price": 30,
          "option1": "Distressed",
          "option2": null,
          "option3": null,
          "image": null
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/forgotten-secret-out-for-the-season.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "fs-crop-sweatshirt",
      "id": 6647761502311,
      "title": "FS Crop Sweatshirt",
      "vendor": "Lonely Floater",
      "available": false,
      "price": 50,
      "priceMin": 50,
      "priceMax": 50,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/fs-crop-sweatshirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-dusty-blue-front-634b09a8b986c.png?v=1666801796",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-dusty-blue-front-634b09a8b986c.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-dusty-blue-back-634b09a8b9c56.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-black-front-634b09a8b45db.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-black-back-634b09a8b8540.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-navy-front-634b09a8b8688.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-navy-back-634b09a8b8877.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-brick-front-634b09a8b8af5.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-brick-back-634b09a8b8e09.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-mauve-front-634b09a8b90f6.png?v=1666801796",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-mauve-back-634b09a8b94de.png?v=1666801796"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Mauve",
            "Dusty Blue"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L"
          ]
        }
      ],
      "variants": [
        {
          "id": 39657272344679,
          "title": "Black / S",
          "available": false,
          "price": 50,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-black-front-634b09a8b45db.png?v=1666801796"
        },
        {
          "id": 39657272442983,
          "title": "Mauve / S",
          "available": false,
          "price": 50,
          "option1": "Mauve",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-mauve-front-634b09a8b90f6.png?v=1666801796"
        },
        {
          "id": 39657272475751,
          "title": "Dusty Blue / S",
          "available": false,
          "price": 50,
          "option1": "Dusty Blue",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-dusty-blue-front-634b09a8b986c.png?v=1666801796"
        },
        {
          "id": 39657272508519,
          "title": "Black / M",
          "available": false,
          "price": 50,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-black-front-634b09a8b45db.png?v=1666801796"
        },
        {
          "id": 39657272639591,
          "title": "Mauve / M",
          "available": false,
          "price": 50,
          "option1": "Mauve",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-mauve-front-634b09a8b90f6.png?v=1666801796"
        },
        {
          "id": 39657272672359,
          "title": "Dusty Blue / M",
          "available": false,
          "price": 50,
          "option1": "Dusty Blue",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-dusty-blue-front-634b09a8b986c.png?v=1666801796"
        },
        {
          "id": 39657272705127,
          "title": "Black / L",
          "available": false,
          "price": 50,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-black-front-634b09a8b45db.png?v=1666801796"
        },
        {
          "id": 39657272803431,
          "title": "Mauve / L",
          "available": false,
          "price": 50,
          "option1": "Mauve",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-mauve-front-634b09a8b90f6.png?v=1666801796"
        },
        {
          "id": 39657272836199,
          "title": "Dusty Blue / L",
          "available": false,
          "price": 50,
          "option1": "Dusty Blue",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/womens-cropped-sweatshirt-dusty-blue-front-634b09a8b986c.png?v=1666801796"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fs-crop-sweatshirt.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "lfx-bleu-unisex-hoodie",
      "id": 4732711796839,
      "title": "LFX FS Bleu Unisex Hoodie",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 46,
      "priceMin": 46,
      "priceMax": 55.99,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/lfx-bleu-unisex-hoodie",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-88519383.png?v=1611040844"
      ],
      "options": [
        {
          "name": "Size",
          "position": 1,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 32934183141479,
          "title": "S",
          "available": true,
          "price": 55.99,
          "option1": "S",
          "option2": null,
          "option3": null,
          "image": null
        },
        {
          "id": 32934183174247,
          "title": "M",
          "available": true,
          "price": 55.99,
          "option1": "M",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        },
        {
          "id": 32934183207015,
          "title": "L",
          "available": true,
          "price": 55.99,
          "option1": "L",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        },
        {
          "id": 32934183239783,
          "title": "XL",
          "available": true,
          "price": 55.99,
          "option1": "XL",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        },
        {
          "id": 32934183272551,
          "title": "2XL",
          "available": true,
          "price": 55.99,
          "option1": "2XL",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        },
        {
          "id": 32934183305319,
          "title": "3XL",
          "available": true,
          "price": 55.99,
          "option1": "3XL",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        },
        {
          "id": 32934183338087,
          "title": "4XL",
          "available": true,
          "price": 55.99,
          "option1": "4XL",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        },
        {
          "id": 32934183370855,
          "title": "5XL",
          "available": true,
          "price": 46,
          "option1": "5XL",
          "option2": null,
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/mockup-6162dc72.png?v=1611040844"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/lfx-bleu-unisex-hoodie.js",
      "checkedAt": "2026-10-02T18:44:49.534Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T18:44:49.534Z"
      }
    },
    {
      "handle": "2-angels-in-the-sky-tee",
      "id": 6687949783143,
      "title": "2 ANGELS IN THE SKY TEE",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 39.5,
      "priceMin": 39.5,
      "priceMax": 40,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/2-angels-in-the-sky-tee",
      "image": "assets/ranked-2-angels-in-the-sky-tee-c783d2fc24.webp",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/2-angels-in-the-sky-tee-transparent-5.png?v=1778198085",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/2-angels-in-the-sky-tee-transparent-6.png?v=1778198095",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/2-angels-in-the-sky-tee-transparent-7.png?v=1778198102",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/2-angels-in-the-sky-tee-transparent-8.png?v=1778198110",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/2-angels-in-the-sky-tee-transparent-9.png?v=1778198118",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/2-angels-in-the-sky-tee-transparent-10.png?v=1778198128",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-back-6a58401a739cf.png?v=1784168486",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-left-6a58401a74843.png?v=1784168486",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-right-6a58401a7551b.png?v=1784168486",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-front-6a584a1ff3457.png?v=1784171049",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-back-6a584a2000750.png?v=1784171049",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-back-6a584aac1398b.jpg?v=1784171188",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-back-6a584c393d737.jpg?v=1784171585",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-front-6a584c7a79098.jpg?v=1784171649",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-back-6a584c7a7a99a.jpg?v=1784171650"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Brown",
            "Forest",
            "Army",
            "Olive"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39902270390375,
          "title": "Black / XS",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270423143,
          "title": "Black / S",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270455911,
          "title": "Black / M",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270521447,
          "title": "Black / L",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270554215,
          "title": "Black / XL",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270586983,
          "title": "Black / 2XL",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270619751,
          "title": "Black / 3XL",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270652519,
          "title": "Black / 4XL",
          "available": true,
          "price": 39.5,
          "option1": "Black",
          "option2": "4XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 39902270685287,
          "title": "Black / 5XL",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "5XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-black-front-6a584aac12326.jpg?v=1784171188"
        },
        {
          "id": 43647006540064,
          "title": "Brown / XS",
          "available": false,
          "price": 39.5,
          "option1": "Brown",
          "option2": "XS",
          "option3": null,
          "image": null
        },
        {
          "id": 39902270718055,
          "title": "Brown / S",
          "available": true,
          "price": 39.5,
          "option1": "Brown",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-front-6a584a1ff3457.png?v=1784171049"
        },
        {
          "id": 39902270750823,
          "title": "Brown / M",
          "available": true,
          "price": 39.5,
          "option1": "Brown",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-front-6a584a1ff3457.png?v=1784171049"
        },
        {
          "id": 39902270783591,
          "title": "Brown / L",
          "available": true,
          "price": 39.5,
          "option1": "Brown",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-front-6a584a1ff3457.png?v=1784171049"
        },
        {
          "id": 39902270816359,
          "title": "Brown / XL",
          "available": true,
          "price": 39.5,
          "option1": "Brown",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-front-6a584a1ff3457.png?v=1784171049"
        },
        {
          "id": 39902270849127,
          "title": "Brown / 2XL",
          "available": true,
          "price": 39.5,
          "option1": "Brown",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-brown-front-6a584a1ff3457.png?v=1784171049"
        },
        {
          "id": 43647006572832,
          "title": "Brown / 3XL",
          "available": false,
          "price": 39.5,
          "option1": "Brown",
          "option2": "3XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006605600,
          "title": "Brown / 4XL",
          "available": false,
          "price": 39.5,
          "option1": "Brown",
          "option2": "4XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006638368,
          "title": "Brown / 5XL",
          "available": false,
          "price": 39.5,
          "option1": "Brown",
          "option2": "5XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006671136,
          "title": "Forest / XS",
          "available": false,
          "price": 39.5,
          "option1": "Forest",
          "option2": "XS",
          "option3": null,
          "image": null
        },
        {
          "id": 39902270881895,
          "title": "Forest / S",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 39902270947431,
          "title": "Forest / M",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 39902270980199,
          "title": "Forest / L",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 39902271012967,
          "title": "Forest / XL",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 39902271045735,
          "title": "Forest / 2XL",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 39902271078503,
          "title": "Forest / 3XL",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 39902271111271,
          "title": "Forest / 4XL",
          "available": true,
          "price": 39.5,
          "option1": "Forest",
          "option2": "4XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-forest-front-6a584c393b70c.jpg?v=1784171585"
        },
        {
          "id": 43647006703904,
          "title": "Forest / 5XL",
          "available": false,
          "price": 39.5,
          "option1": "Forest",
          "option2": "5XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006736672,
          "title": "Army / XS",
          "available": false,
          "price": 39.5,
          "option1": "Army",
          "option2": "XS",
          "option3": null,
          "image": null
        },
        {
          "id": 39902271144039,
          "title": "Army / S",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 39902271176807,
          "title": "Army / M",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 39902271242343,
          "title": "Army / L",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 39902271307879,
          "title": "Army / XL",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 39902271340647,
          "title": "Army / 2XL",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 39902271373415,
          "title": "Army / 3XL",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 39902271406183,
          "title": "Army / 4XL",
          "available": true,
          "price": 39.5,
          "option1": "Army",
          "option2": "4XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-army-front-6a58401a71ea4.png?v=1784168486"
        },
        {
          "id": 43647006769440,
          "title": "Army / 5XL",
          "available": false,
          "price": 39.5,
          "option1": "Army",
          "option2": "5XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006802208,
          "title": "Olive / XS",
          "available": false,
          "price": 39.5,
          "option1": "Olive",
          "option2": "XS",
          "option3": null,
          "image": null
        },
        {
          "id": 39902271438951,
          "title": "Olive / S",
          "available": true,
          "price": 39.5,
          "option1": "Olive",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-front-6a584c7a79098.jpg?v=1784171649"
        },
        {
          "id": 39902271471719,
          "title": "Olive / M",
          "available": true,
          "price": 39.5,
          "option1": "Olive",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-front-6a584c7a79098.jpg?v=1784171649"
        },
        {
          "id": 39902271504487,
          "title": "Olive / L",
          "available": true,
          "price": 39.5,
          "option1": "Olive",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-front-6a584c7a79098.jpg?v=1784171649"
        },
        {
          "id": 39902271537255,
          "title": "Olive / XL",
          "available": true,
          "price": 39.5,
          "option1": "Olive",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-front-6a584c7a79098.jpg?v=1784171649"
        },
        {
          "id": 39902271602791,
          "title": "Olive / 2XL",
          "available": true,
          "price": 39.5,
          "option1": "Olive",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/unisex-staple-t-shirt-olive-front-6a584c7a79098.jpg?v=1784171649"
        },
        {
          "id": 43647006834976,
          "title": "Olive / 3XL",
          "available": false,
          "price": 39.5,
          "option1": "Olive",
          "option2": "3XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006867744,
          "title": "Olive / 4XL",
          "available": false,
          "price": 39.5,
          "option1": "Olive",
          "option2": "4XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43647006900512,
          "title": "Olive / 5XL",
          "available": false,
          "price": 39.5,
          "option1": "Olive",
          "option2": "5XL",
          "option3": null,
          "image": null
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/2-angels-in-the-sky-tee.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "fs-embroidered-sweatshirt",
      "id": 6646643294311,
      "title": "FS Embroidered Sweatshirt",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 40,
      "priceMin": 40,
      "priceMax": 48.99,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/fs-embroidered-sweatshirt",
      "image": "assets/ranked-fs-embroidered-sweatshirt-f8e808352c.webp",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/fs-embroidered-sweatshirt-transparent-1.png?v=1778221757",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-front-6359d445d4089.png?v=1666831439",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-back-6359d445d5c5c.png?v=1666831442",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-back-6359d45e58b4c.png?v=1666831469"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Maroon",
            "Military Green"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39652354326631,
          "title": "Black / S",
          "available": true,
          "price": 48.99,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354359399,
          "title": "Black / M",
          "available": true,
          "price": 48.99,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354392167,
          "title": "Black / L",
          "available": true,
          "price": 48.99,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354424935,
          "title": "Black / XL",
          "available": true,
          "price": 48.99,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354457703,
          "title": "Black / 2XL",
          "available": true,
          "price": 48.99,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354490471,
          "title": "Black / 3XL",
          "available": true,
          "price": 48.99,
          "option1": "Black",
          "option2": "3XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354523239,
          "title": "Black / 4XL",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "4XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39652354588775,
          "title": "Black / 5XL",
          "available": true,
          "price": 41.5,
          "option1": "Black",
          "option2": "5XL",
          "option3": null,
          "image": null
        },
        {
          "id": 43666843402528,
          "title": "Maroon / S",
          "available": true,
          "price": 48.99,
          "option1": "Maroon",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-front-6359d445d4089.png?v=1666831439"
        },
        {
          "id": 43666843435296,
          "title": "Maroon / M",
          "available": true,
          "price": 48.99,
          "option1": "Maroon",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-front-6359d445d4089.png?v=1666831439"
        },
        {
          "id": 43666843468064,
          "title": "Maroon / L",
          "available": true,
          "price": 48.99,
          "option1": "Maroon",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-front-6359d445d4089.png?v=1666831439"
        },
        {
          "id": 43666843500832,
          "title": "Maroon / XL",
          "available": true,
          "price": 48.99,
          "option1": "Maroon",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-front-6359d445d4089.png?v=1666831439"
        },
        {
          "id": 43666843533600,
          "title": "Maroon / 2XL",
          "available": true,
          "price": 48.99,
          "option1": "Maroon",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-maroon-front-6359d445d4089.png?v=1666831439"
        },
        {
          "id": 43666843566368,
          "title": "Military Green / S",
          "available": true,
          "price": 48.99,
          "option1": "Military Green",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465"
        },
        {
          "id": 43666843599136,
          "title": "Military Green / M",
          "available": true,
          "price": 48.99,
          "option1": "Military Green",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465"
        },
        {
          "id": 43666843631904,
          "title": "Military Green / L",
          "available": true,
          "price": 48.99,
          "option1": "Military Green",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465"
        },
        {
          "id": 43666843664672,
          "title": "Military Green / XL",
          "available": true,
          "price": 48.99,
          "option1": "Military Green",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465"
        },
        {
          "id": 43666843697440,
          "title": "Military Green / 2XL",
          "available": true,
          "price": 48.99,
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465"
        },
        {
          "id": 43666843730208,
          "title": "Military Green / 3XL",
          "available": true,
          "price": 48.99,
          "option1": "Military Green",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-crew-neck-sweatshirt-military-green-front-6359d45e5490d.png?v=1666831465"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fs-embroidered-sweatshirt.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "limited-edition-skate-tee-long-sleeve-tee",
      "id": 6707285459047,
      "title": "Limited Edition KOTA Skate Tee",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 37,
      "priceMin": 37,
      "priceMax": 47,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/limited-edition-skate-tee-long-sleeve-tee",
      "image": "assets/ranked-limited-edition-skate-tee-long-sleeve-tee-f54e25e259.webp",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-back-6358be35c115b.png?v=1666760259",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-back-6358be7db37aa.png?v=1666760331",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-back-6358bf86d015d.png?v=1666760594",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-back-6358bfac60ade.png?v=1666760634"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Poppy",
            "Military Green",
            "Gold"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39910782337127,
          "title": "Black / XS",
          "available": true,
          "price": 37,
          "option1": "Black",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592"
        },
        {
          "id": 39910782369895,
          "title": "Black / S",
          "available": true,
          "price": 37,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592"
        },
        {
          "id": 39910782402663,
          "title": "Black / M",
          "available": true,
          "price": 37,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592"
        },
        {
          "id": 39910782435431,
          "title": "Black / L",
          "available": true,
          "price": 37,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592"
        },
        {
          "id": 39910782468199,
          "title": "Black / XL",
          "available": true,
          "price": 37,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592"
        },
        {
          "id": 39910782500967,
          "title": "Black / 2XL",
          "available": true,
          "price": 39,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bf86cd08c.png?v=1666760592"
        },
        {
          "id": 43646982291744,
          "title": "Poppy / XS",
          "available": false,
          "price": 44,
          "option1": "Poppy",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256"
        },
        {
          "id": 43646982324512,
          "title": "Poppy / S",
          "available": false,
          "price": 44,
          "option1": "Poppy",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256"
        },
        {
          "id": 43646982357280,
          "title": "Poppy / M",
          "available": false,
          "price": 44,
          "option1": "Poppy",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256"
        },
        {
          "id": 43646982390048,
          "title": "Poppy / L",
          "available": false,
          "price": 44,
          "option1": "Poppy",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256"
        },
        {
          "id": 43646982553888,
          "title": "Poppy / XL",
          "available": false,
          "price": 44,
          "option1": "Poppy",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256"
        },
        {
          "id": 43646982586656,
          "title": "Poppy / 2XL",
          "available": false,
          "price": 47,
          "option1": "Poppy",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-poppy-front-6358be35bd84f.png?v=1666760256"
        },
        {
          "id": 43646982619424,
          "title": "Military Green / XS",
          "available": true,
          "price": 44,
          "option1": "Military Green",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631"
        },
        {
          "id": 43646982652192,
          "title": "Military Green / S",
          "available": true,
          "price": 44,
          "option1": "Military Green",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631"
        },
        {
          "id": 43646982717728,
          "title": "Military Green / M",
          "available": true,
          "price": 44,
          "option1": "Military Green",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631"
        },
        {
          "id": 43646982750496,
          "title": "Military Green / L",
          "available": true,
          "price": 44,
          "option1": "Military Green",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631"
        },
        {
          "id": 43646982783264,
          "title": "Military Green / XL",
          "available": true,
          "price": 44,
          "option1": "Military Green",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631"
        },
        {
          "id": 43646982816032,
          "title": "Military Green / 2XL",
          "available": true,
          "price": 47,
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bfac5dd76.png?v=1666760631"
        },
        {
          "id": 43646982848800,
          "title": "Gold / XS",
          "available": false,
          "price": 44,
          "option1": "Gold",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328"
        },
        {
          "id": 43646982914336,
          "title": "Gold / S",
          "available": true,
          "price": 44,
          "option1": "Gold",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328"
        },
        {
          "id": 43646982947104,
          "title": "Gold / M",
          "available": true,
          "price": 44,
          "option1": "Gold",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328"
        },
        {
          "id": 43646982979872,
          "title": "Gold / L",
          "available": true,
          "price": 44,
          "option1": "Gold",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328"
        },
        {
          "id": 43646983012640,
          "title": "Gold / XL",
          "available": true,
          "price": 44,
          "option1": "Gold",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328"
        },
        {
          "id": 43646983045408,
          "title": "Gold / 2XL",
          "available": true,
          "price": 47,
          "option1": "Gold",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-gold-front-6358be7db2a93.png?v=1666760328"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/limited-edition-skate-tee-long-sleeve-tee.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "travis-kanji-t-shirt",
      "id": 6577190109287,
      "title": "Travis Kanji  T-Shirt",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 28,
      "priceMin": 28,
      "priceMax": 31.99,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/travis-kanji-t-shirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/files/travis-kanji--t-shirt-transparent-1.png?v=1778227073",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/files/travis-kanji--t-shirt-transparent-1.png?v=1778227073",
        "https://cdn.shopify.com/s/files/1/1757/0299/files/travis-kanji--t-shirt-transparent-2.png?v=1778227082"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "White"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39413184430183,
          "title": "Black / XS",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "XS",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184462951,
          "title": "Black / S",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184495719,
          "title": "Black / M",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184528487,
          "title": "Black / L",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184561255,
          "title": "Black / XL",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184594023,
          "title": "Black / 2XL",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184626791,
          "title": "Black / 3XL",
          "available": true,
          "price": 31.99,
          "option1": "Black",
          "option2": "3XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184659559,
          "title": "Black / 4XL",
          "available": true,
          "price": 28,
          "option1": "Black",
          "option2": "4XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184692327,
          "title": "White / XS",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "XS",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184725095,
          "title": "White / S",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "S",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184757863,
          "title": "White / M",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "M",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184790631,
          "title": "White / L",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "L",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184823399,
          "title": "White / XL",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184856167,
          "title": "White / 2XL",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "2XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184888935,
          "title": "White / 3XL",
          "available": true,
          "price": 31.99,
          "option1": "White",
          "option2": "3XL",
          "option3": null,
          "image": null
        },
        {
          "id": 39413184921703,
          "title": "White / 4XL",
          "available": true,
          "price": 28,
          "option1": "White",
          "option2": "4XL",
          "option3": null,
          "image": null
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/travis-kanji-t-shirt.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "fly-at-your-own-alt-long-tee",
      "id": 6710966616167,
      "title": "Fly At Your Own Alt. Long Sleeve Tee",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 40,
      "priceMin": 40,
      "priceMax": 42,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/fly-at-your-own-alt-long-tee",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-back-6358bdd4ef9f6.png?v=1666760165",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-back-6358bdd4efe04.png?v=1666760170",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-back-6358bdd4f036b.png?v=1666760176"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "Military Green"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39921926537319,
          "title": "Black / XS",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162"
        },
        {
          "id": 39921926570087,
          "title": "Black / S",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162"
        },
        {
          "id": 39921926602855,
          "title": "Black / M",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162"
        },
        {
          "id": 39921926635623,
          "title": "Black / L",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162"
        },
        {
          "id": 39921926668391,
          "title": "Black / XL",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162"
        },
        {
          "id": 39921926701159,
          "title": "Black / 2XL",
          "available": true,
          "price": 40,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358bdd4ef118.png?v=1666760162"
        },
        {
          "id": 39921926733927,
          "title": "Navy / XS",
          "available": true,
          "price": 40,
          "option1": "Navy",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167"
        },
        {
          "id": 39921926766695,
          "title": "Navy / S",
          "available": true,
          "price": 40,
          "option1": "Navy",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167"
        },
        {
          "id": 39921926799463,
          "title": "Navy / M",
          "available": true,
          "price": 40,
          "option1": "Navy",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167"
        },
        {
          "id": 39921926832231,
          "title": "Navy / L",
          "available": true,
          "price": 40,
          "option1": "Navy",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167"
        },
        {
          "id": 39921926864999,
          "title": "Navy / XL",
          "available": true,
          "price": 40,
          "option1": "Navy",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167"
        },
        {
          "id": 39921926897767,
          "title": "Navy / 2XL",
          "available": true,
          "price": 40,
          "option1": "Navy",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358bdd4efb74.png?v=1666760167"
        },
        {
          "id": 39921926930535,
          "title": "Military Green / XS",
          "available": true,
          "price": 40,
          "option1": "Military Green",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173"
        },
        {
          "id": 39921926963303,
          "title": "Military Green / S",
          "available": true,
          "price": 40,
          "option1": "Military Green",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173"
        },
        {
          "id": 39921926996071,
          "title": "Military Green / M",
          "available": true,
          "price": 40,
          "option1": "Military Green",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173"
        },
        {
          "id": 39921927028839,
          "title": "Military Green / L",
          "available": true,
          "price": 40,
          "option1": "Military Green",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173"
        },
        {
          "id": 39921927061607,
          "title": "Military Green / XL",
          "available": true,
          "price": 40,
          "option1": "Military Green",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173"
        },
        {
          "id": 39921927094375,
          "title": "Military Green / 2XL",
          "available": true,
          "price": 42,
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358bdd4f0045.png?v=1666760173"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/fly-at-your-own-alt-long-tee.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "vision-quest-unisex-hoodie",
      "id": 6647757471847,
      "title": "Forgotten Secret 2.0 Set Upper Unisex Hoodie",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 53,
      "priceMin": 53,
      "priceMax": 58,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/vision-quest-unisex-hoodie",
      "image": "assets/ranked-vision-quest-unisex-hoodie-6073a1aedc.webp",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Carbon Grey",
            "Navy Blazer"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39657249210471,
          "title": "Black / S",
          "available": true,
          "price": 53,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985"
        },
        {
          "id": 39657249243239,
          "title": "Carbon Grey / S",
          "available": true,
          "price": 53,
          "option1": "Carbon Grey",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
        },
        {
          "id": 39657249276007,
          "title": "Navy Blazer / S",
          "available": true,
          "price": 53,
          "option1": "Navy Blazer",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988"
        },
        {
          "id": 39657249308775,
          "title": "Carbon Grey / M",
          "available": true,
          "price": 53,
          "option1": "Carbon Grey",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
        },
        {
          "id": 39657249341543,
          "title": "Navy Blazer / M",
          "available": true,
          "price": 53,
          "option1": "Navy Blazer",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988"
        },
        {
          "id": 39657249374311,
          "title": "Black / M",
          "available": true,
          "price": 53,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985"
        },
        {
          "id": 39657249407079,
          "title": "Black / L",
          "available": true,
          "price": 53,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985"
        },
        {
          "id": 39657249439847,
          "title": "Carbon Grey / L",
          "available": true,
          "price": 53,
          "option1": "Carbon Grey",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
        },
        {
          "id": 39657249472615,
          "title": "Navy Blazer / L",
          "available": true,
          "price": 53,
          "option1": "Navy Blazer",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988"
        },
        {
          "id": 39657249505383,
          "title": "Carbon Grey / XL",
          "available": true,
          "price": 53,
          "option1": "Carbon Grey",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
        },
        {
          "id": 39657249538151,
          "title": "Navy Blazer / XL",
          "available": true,
          "price": 53,
          "option1": "Navy Blazer",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988"
        },
        {
          "id": 39657249570919,
          "title": "Black / XL",
          "available": true,
          "price": 53,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985"
        },
        {
          "id": 39657249603687,
          "title": "Navy Blazer / 2XL",
          "available": true,
          "price": 55.5,
          "option1": "Navy Blazer",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988"
        },
        {
          "id": 39657249636455,
          "title": "Black / 2XL",
          "available": true,
          "price": 55.5,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985"
        },
        {
          "id": 39657249669223,
          "title": "Carbon Grey / 2XL",
          "available": true,
          "price": 55.5,
          "option1": "Carbon Grey",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
        },
        {
          "id": 39657249701991,
          "title": "Navy Blazer / 3XL",
          "available": true,
          "price": 58,
          "option1": "Navy Blazer",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-navy-blazer-front-634c2294dcf6a.png?v=1665933988"
        },
        {
          "id": 39657249734759,
          "title": "Black / 3XL",
          "available": true,
          "price": 58,
          "option1": "Black",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-black-front-634c2294dbc0a.png?v=1665933985"
        },
        {
          "id": 39657249767527,
          "title": "Carbon Grey / 3XL",
          "available": true,
          "price": 58,
          "option1": "Carbon Grey",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-hoodie-carbon-grey-front-634c2294ddbb8.png?v=1665933991"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/vision-quest-unisex-hoodie.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      },
      "displayTitle": "Forgotten Secret Hoodie",
      "imageAlt": "Black Forgotten Secret hoodie with Lonely Floater balloon emblem on the chest."
    },
    {
      "handle": "shine-bright-tee-unisex-long-sleeve-tee",
      "id": 7959702208800,
      "title": "SHINE BRIGHT TEE Unisex Long Sleeve Tee",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 33.5,
      "priceMin": 33.5,
      "priceMax": 35.5,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/shine-bright-tee-unisex-long-sleeve-tee",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-back-6358b277e6a87.png?v=1666757256",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-back-6358b277e6ef5.png?v=1666757262",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-back-6358b277e74f6.png?v=1666757268"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Navy",
            "Military Green"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "2XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 43630699839776,
          "title": "Black / XS",
          "available": true,
          "price": 33.5,
          "option1": "Black",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253"
        },
        {
          "id": 43630699872544,
          "title": "Black / S",
          "available": true,
          "price": 33.5,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253"
        },
        {
          "id": 43630699905312,
          "title": "Black / M",
          "available": true,
          "price": 33.5,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253"
        },
        {
          "id": 43630699938080,
          "title": "Black / L",
          "available": true,
          "price": 33.5,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253"
        },
        {
          "id": 43630699970848,
          "title": "Black / XL",
          "available": true,
          "price": 33.5,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253"
        },
        {
          "id": 43630700003616,
          "title": "Black / 2XL",
          "available": true,
          "price": 35.5,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-black-front-6358b277e15fc.png?v=1666757253"
        },
        {
          "id": 43630700036384,
          "title": "Navy / XS",
          "available": true,
          "price": 33.5,
          "option1": "Navy",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259"
        },
        {
          "id": 43630700069152,
          "title": "Navy / S",
          "available": true,
          "price": 33.5,
          "option1": "Navy",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259"
        },
        {
          "id": 43630700101920,
          "title": "Navy / M",
          "available": true,
          "price": 33.5,
          "option1": "Navy",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259"
        },
        {
          "id": 43630700134688,
          "title": "Navy / L",
          "available": true,
          "price": 33.5,
          "option1": "Navy",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259"
        },
        {
          "id": 43630700167456,
          "title": "Navy / XL",
          "available": true,
          "price": 33.5,
          "option1": "Navy",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259"
        },
        {
          "id": 43630700200224,
          "title": "Navy / 2XL",
          "available": true,
          "price": 35.5,
          "option1": "Navy",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-navy-front-6358b277e6c65.png?v=1666757259"
        },
        {
          "id": 43630700232992,
          "title": "Military Green / XS",
          "available": true,
          "price": 33.5,
          "option1": "Military Green",
          "option2": "XS",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265"
        },
        {
          "id": 43630700265760,
          "title": "Military Green / S",
          "available": true,
          "price": 33.5,
          "option1": "Military Green",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265"
        },
        {
          "id": 43630700298528,
          "title": "Military Green / M",
          "available": true,
          "price": 33.5,
          "option1": "Military Green",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265"
        },
        {
          "id": 43630700331296,
          "title": "Military Green / L",
          "available": true,
          "price": 33.5,
          "option1": "Military Green",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265"
        },
        {
          "id": 43630700364064,
          "title": "Military Green / XL",
          "available": true,
          "price": 33.5,
          "option1": "Military Green",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265"
        },
        {
          "id": 43630700396832,
          "title": "Military Green / 2XL",
          "available": true,
          "price": 35.5,
          "option1": "Military Green",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-long-sleeve-tee-military-green-front-6358b277e7152.png?v=1666757265"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/shine-bright-tee-unisex-long-sleeve-tee.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    },
    {
      "handle": "king-of-the-autumn-unisex-premium-sweatshirt",
      "id": 6703104163943,
      "title": "King of the Autumn Unisex Premium Sweatshirt",
      "vendor": "Lonely Floater",
      "available": true,
      "price": 46.25,
      "priceMin": 46.25,
      "priceMax": 53.5,
      "currency": "USD",
      "url": "https://lonelyfloater.com/products/king-of-the-autumn-unisex-premium-sweatshirt",
      "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520",
      "images": [
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-back-6359ccc392ac9.png?v=1666829524",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726",
        "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-back-6359cd818e6fb.png?v=1666829730"
      ],
      "options": [
        {
          "name": "Color",
          "position": 1,
          "values": [
            "Black",
            "Forest Green"
          ]
        },
        {
          "name": "Size",
          "position": 2,
          "values": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
          ]
        }
      ],
      "variants": [
        {
          "id": 39895248568423,
          "title": "Black / S",
          "available": true,
          "price": 46.25,
          "option1": "Black",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520"
        },
        {
          "id": 39895248601191,
          "title": "Black / M",
          "available": true,
          "price": 46.25,
          "option1": "Black",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520"
        },
        {
          "id": 39895248633959,
          "title": "Black / L",
          "available": true,
          "price": 46.25,
          "option1": "Black",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520"
        },
        {
          "id": 39895248666727,
          "title": "Black / XL",
          "available": true,
          "price": 46.25,
          "option1": "Black",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520"
        },
        {
          "id": 39895248699495,
          "title": "Black / 2XL",
          "available": true,
          "price": 47.7,
          "option1": "Black",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520"
        },
        {
          "id": 39895248732263,
          "title": "Black / 3XL",
          "available": true,
          "price": 49.39,
          "option1": "Black",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-black-front-6359ccc38fa7f.png?v=1666829520"
        },
        {
          "id": 43676993978656,
          "title": "Forest Green / S",
          "available": true,
          "price": 49,
          "option1": "Forest Green",
          "option2": "S",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726"
        },
        {
          "id": 43676994011424,
          "title": "Forest Green / M",
          "available": true,
          "price": 49,
          "option1": "Forest Green",
          "option2": "M",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726"
        },
        {
          "id": 43676994044192,
          "title": "Forest Green / L",
          "available": true,
          "price": 49,
          "option1": "Forest Green",
          "option2": "L",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726"
        },
        {
          "id": 43676994076960,
          "title": "Forest Green / XL",
          "available": true,
          "price": 49,
          "option1": "Forest Green",
          "option2": "XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726"
        },
        {
          "id": 43676994109728,
          "title": "Forest Green / 2XL",
          "available": true,
          "price": 51,
          "option1": "Forest Green",
          "option2": "2XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726"
        },
        {
          "id": 43676994142496,
          "title": "Forest Green / 3XL",
          "available": true,
          "price": 53.5,
          "option1": "Forest Green",
          "option2": "3XL",
          "option3": null,
          "image": "https://cdn.shopify.com/s/files/1/1757/0299/products/unisex-premium-sweatshirt-forest-green-front-6359cd8186bc9.png?v=1666829726"
        }
      ],
      "collectionHandles": [],
      "publicSource": "https://lonelyfloater.com/products/king-of-the-autumn-unisex-premium-sweatshirt.js",
      "checkedAt": "2026-10-02T19:11:21.250Z",
      "stockVerification": {
        "status": "verified",
        "checkedAt": "2026-10-02T19:11:21.250Z"
      }
    }
  ],
  "players": {
    "aveek": {
      "title": "The Uncharted EP — Aveek",
      "src": "https://open.spotify.com/embed/album/0wyV0hZNZkK1T1FHnZPt3M?theme=0",
      "href": "https://bfan.link/the-uncharted",
      "height": 352
    },
    "travis": {
      "title": "Family Business — Travis Michael",
      "src": "https://open.spotify.com/embed/album/62b7EBfWFbGQcpvOwZtyxL?theme=0",
      "href": "https://open.spotify.com/album/62b7EBfWFbGQcpvOwZtyxL",
      "height": 352
    },
    "playlist": {
      "title": "Floater Society Sound on Spotify",
      "src": "https://open.spotify.com/embed/playlist/3eZGOjACqJaTXNlBYbRXRp?theme=0",
      "href": "https://open.spotify.com/playlist/3eZGOjACqJaTXNlBYbRXRp",
      "height": 352
    },
    "apple": {
      "title": "Floater Society Sound on Apple Music",
      "src": "https://embed.music.apple.com/us/playlist/lf-mood/pl.u-V9D7LPEUPq367Z?theme=dark",
      "href": "https://music.apple.com/us/playlist/lf-mood/pl.u-V9D7LPEUPq367Z",
      "height": 352
    }
  },
  "videos": [
    {
      "id": "t-1tdwpC8pc",
      "artist": "LISA MARAIS",
      "title": "SINCE YOU WANNA KNOW",
      "poster": "assets/youtube-t-1tdwpC8pc.webp"
    },
    {
      "id": "3XQh88I-ipA",
      "artist": "TENEO",
      "title": "ELEVATE",
      "poster": "assets/youtube-3XQh88I-ipA.webp"
    },
    {
      "id": "lfw_jRJR8bE",
      "artist": "BOSS HEAVY FEAT. LIVA",
      "title": "HASTA MAÑANA",
      "poster": "assets/youtube-lfw_jRJR8bE.webp"
    },
    {
      "id": "wK0PG-1gLx8",
      "artist": "LOCAL HEAT / MARTY GRIMES",
      "title": "ME 4 ME — LIVE",
      "poster": "assets/youtube-wK0PG-1gLx8.webp"
    }
  ],
  "videoGallery": [
    { "id": "Q1opjocg_4k", "artist": "AVEEK", "title": "SXOD", "poster": "assets/youtube-Q1opjocg_4k.webp" },
    { "id": "ccsWeycZwXU", "artist": "AUX & MIC / C5", "title": "IN HIS OWN WORDS", "poster": "assets/youtube-ccsWeycZwXU.webp" },
    { "id": "HrpJUpuyvmQ", "artist": "LOCAL HEAT / BOSS HEAVY", "title": "LEMON PEPPER FREESTYLE", "poster": "assets/youtube-HrpJUpuyvmQ.webp" },
    { "id": "3XQh88I-ipA", "artist": "TENEO", "title": "ELEVATE", "poster": "assets/youtube-3XQh88I-ipA.webp" },
    { "id": "wK0PG-1gLx8", "artist": "LOCAL HEAT / MARTY GRIMES", "title": "ME 4 ME — LIVE", "poster": "assets/youtube-wK0PG-1gLx8.webp" },
    { "id": "k7ZVTVNHVoE", "artist": "LOCAL HEAT / EBBIE AKBAR", "title": "PLAYER — LIVE", "poster": "assets/youtube-k7ZVTVNHVoE.webp" }
  ],
  "social": [
    {
      "src": "assets/community-0.webp",
      "alt": "Night subway portrait with branded duffle",
      "caption": "THE CITY AFTER DARK",
      "href": "https://www.instagram.com/lonelyfloater/"
    },
    {
      "src": "assets/community-1.webp",
      "alt": "Two friends in Floater jerseys with graffiti backdrop",
      "caption": "THE PEOPLE. THE PIECES.",
      "href": "https://www.instagram.com/lonelyfloater/"
    },
    {
      "src": "assets/community-2.webp",
      "alt": "Blue and white hats worn together",
      "caption": "FLOAT TOGETHER.",
      "href": "https://www.instagram.com/lonelyfloater/"
    },
    {
      "src": "assets/community-3.webp",
      "alt": "Street portrait crouched by black car",
      "caption": "IN YOUR OWN ELEMENT.",
      "href": "https://www.instagram.com/lonelyfloater/"
    },
    {
      "src": "assets/community-4.webp",
      "alt": "Person wearing a black Lonely Floater dad hat with the red balloon embroidery",
      "caption": "THE RED BALLOON.",
      "href": "https://www.instagram.com/lonelyfloater/"
    },
    {
      "src": "assets/community-5.webp",
      "alt": "Person wearing a pink Lonely Floater cap with blue balloon embroidery",
      "caption": "COLOUR OUTSIDE THE LINES.",
      "href": "https://www.instagram.com/lonelyfloater/"
    }
  ],
  "timeline": [
    {
      "year": "2016",
      "text": "The beginning — Mount Vernon, New York."
    },
    {
      "year": "2017",
      "text": "First Flight — the first collection."
    },
    {
      "year": "2020",
      "text": "Trials — the next chapter."
    },
    {
      "year": "2022",
      "text": "Lunar Return & Moonlight Mirage."
    },
    {
      "year": "2025",
      "text": "The Aveek Collection."
    }
  ],
  "media": {
    "hero": {
      "id": "gxqBo3f0uRE",
      "title": "Lonely Floater — main campaign",
      "poster": "assets/youtube-gxqBo3f0uRE.webp"
    },
    "aveek": {
      "id": "E05_i0o5MeQ",
      "title": "Aveek — Back and Fourth (Official Video)",
      "poster": "assets/youtube-E05_i0o5MeQ.webp"
    },
    "bossHeavy": {
      "id": "HrpJUpuyvmQ",
      "title": "Boss Heavy — Lemon Pepper Freestyle",
      "poster": "assets/youtube-HrpJUpuyvmQ.webp"
    },
    "c5": {
      "id": "ccsWeycZwXU",
      "title": "C5 Interview — aUX & mIC",
      "poster": "assets/youtube-ccsWeycZwXU.webp"
    }
  },
  "shopAll": "https://lonelyfloater.com/collections/shop-all",
  "rotationRanking": {
    "source": "Lonely Floater existing page tracker",
    "updatedAt": "2026-10-02T18:44:49.534Z",
    "window": {
      "days": 21,
      "start": "2026-09-11T18:44:49.534Z",
      "end": "2026-10-02T18:44:49.534Z",
      "rolling": true
    },
    "timeMetric": "mean_elapsed_page_seconds_capped_per_visit_at_60",
    "metricDefinitions": {
      "views": "Product-page product_view events after deduplicating collector session and product page; other product handles on that page are excluded.",
      "clicks": "Recorded clicks on this product page, excluding identifiable navigation/footer/header selectors and links to other destinations.",
      "cartInteractions": "Deduplicated product-page sessions containing add_to_cart; at most one attempt per session/page, not completed purchases.",
      "checkoutInteractions": "Deduplicated product-page sessions containing checkout_start; at most one attempt per session/page, not completed purchases.",
      "purchaseIntent": "cartInteractions plus twice checkoutInteractions; click attempts, not actual sales.",
      "averageEngagementSeconds": "Mean elapsed wall-clock product-page time, capped at 60 seconds per visit; not active foreground attention.",
      "imageClicks": "Recorded product-image interactions; kept separate to avoid adding duplicate generic click counts."
    },
    "coverage": {
      "hostname": "lonelyfloater.com",
      "productPageSessions": 267,
      "sessionRecords": 493,
      "limit": 1000,
      "capped": false,
      "attempts": [
        {
          "days": 30,
          "records": 1000,
          "capped": true,
          "ok": true
        },
        {
          "days": 21,
          "records": 493,
          "capped": false,
          "ok": true
        }
      ]
    },
    "weights": {
      "views": 0.38,
      "clicks": 0.18,
      "averageEngagementSeconds": 0.04,
      "purchaseIntent": 0.25,
      "shopifyHumanLandingSessions": 0.15
    },
    "minViews": 3,
    "maxProducts": 4,
    "maxAgeDays": 7,
    "caption": "Selected by product-page views, clicks, cart/checkout interest, Shopify human landings and time on page · last 21 days.",
    "limitations": [
      "Recorded cart/checkout interactions are attempts, not confirmed purchases.",
      "Elapsed page time can include background time and is capped per visit at 60 seconds.",
      "The tracker does not prove human traffic; incomplete selector information may prevent some navigation clicks from being identified.",
      "No collector endpoint, visitor/session IDs, click text or raw visitor records are published."
    ],
    "products": [
      {
        "handle": "travel-bugs-unisex-fleece-sweatpants",
        "views": 8,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 8,
        "averageEngagementSeconds": 6.9
      },
      {
        "handle": "forgotten-vision-bucket",
        "views": 6,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 6,
        "averageEngagementSeconds": 1.67
      },
      {
        "handle": "new-bolo",
        "views": 6,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 6,
        "averageEngagementSeconds": 20.27
      },
      {
        "handle": "forgotten-secret-white-seam-oscuro-beanie-out-for-the-season",
        "views": 5,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 5,
        "averageEngagementSeconds": 12.97
      },
      {
        "handle": "fs-embroidered-t-shirt",
        "views": 5,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 5,
        "averageEngagementSeconds": 25.84
      },
      {
        "handle": "vision-quest-unisex-fleece-sweatpants",
        "views": 5,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 5,
        "averageEngagementSeconds": 21.76
      },
      {
        "handle": "balance-sweatshirt",
        "views": 4,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 4,
        "averageEngagementSeconds": 30.85
      },
      {
        "handle": "for-tee",
        "views": 4,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 4,
        "averageEngagementSeconds": 30.25
      },
      {
        "handle": "allevil-short-sleeve-unisex-t-shirt",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 20.7
      },
      {
        "handle": "aveek-toxic-by-nature-crop-hoodie",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 31.8
      },
      {
        "handle": "dream-big-unisex-t-shirt",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 30.85
      },
      {
        "handle": "dressy-sweats",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "fire-red-t-shirt",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 22.88
      },
      {
        "handle": "fly-at-your-own-altitude-premium-heavyweight-tee",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 14.35
      },
      {
        "handle": "forgotten-secret-out-for-the-season",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 1.72
      },
      {
        "handle": "fs-crop-sweatshirt",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 30.74
      },
      {
        "handle": "lfx-bleu-unisex-hoodie",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 12.7
      },
      {
        "handle": "lonely-floater-lux-hoodie",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 23.57
      },
      {
        "handle": "lonely-floater-x-travis-michael-duffle-bag",
        "views": 3,
        "clicks": 2,
        "imageClicks": 2,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 47.22
      },
      {
        "handle": "long-sleeve-t-shirt",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 18.63
      },
      {
        "handle": "womens-focus-bear-hoodie",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 20.84
      },
      {
        "handle": "womens-tropicamo-crop-hoodie",
        "views": 3,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 3,
        "averageEngagementSeconds": 11.67
      },
      {
        "handle": "coast-2-coast-trucker",
        "views": 2,
        "clicks": 2,
        "imageClicks": 1,
        "cartInteractions": 1,
        "checkoutInteractions": 1,
        "purchaseIntent": 3,
        "productPageSessions": 2,
        "averageEngagementSeconds": 8.55
      },
      {
        "handle": "astro-tee",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "baby-frosty-tee",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30.89
      },
      {
        "handle": "badge-of-the-king-out-for-the-season",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 3.55
      },
      {
        "handle": "copy-of-infant-fine-jersey-bodysuit",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 16.52
      },
      {
        "handle": "earth-socks",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "fs-laced-hoodie",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30.25
      },
      {
        "handle": "fs-no-lace-unisex-hoodie",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "infant-fine-jersey-bodysuit",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "king-of-the-autumn-out-for-the-season",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 5.28
      },
      {
        "handle": "lf-embroidered-champion-backpack",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "lff-long-sleeve-fitted-crew-gym-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30.01
      },
      {
        "handle": "lfx-polo-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 4.26
      },
      {
        "handle": "lime-light-champion-t-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 32.6
      },
      {
        "handle": "limited-edition-skate-tee-long-sleeve-tee",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 16.25
      },
      {
        "handle": "lonely-floater-fs-lunar-return-cuffed-beanie",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 1.26
      },
      {
        "handle": "lonely-floater-large-tote-bag",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 3
      },
      {
        "handle": "lost-snapback-hat",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 16.25
      },
      {
        "handle": "mkga-make-kanye-great-again-fitted",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 16.27
      },
      {
        "handle": "moon-veneration-unisex-t-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 5.61
      },
      {
        "handle": "og-splash-t-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "orange-lonely-floater-mens-champion-t-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 28.59
      },
      {
        "handle": "oscuro-introvert-beanie-out-for-the-season",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 1.62
      },
      {
        "handle": "secure-that-bag-long-sleeve-t-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 20.38
      },
      {
        "handle": "shine-bright-tee-unisex-long-sleeve-tee",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 31.3
      },
      {
        "handle": "short-sleeve-unisex-t-shirt-1",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 31.5
      },
      {
        "handle": "thunda-bubble-free-stickers",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 28.93
      },
      {
        "handle": "thunda-sweatshirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30.4
      },
      {
        "handle": "travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie",
        "views": 2,
        "clicks": 1,
        "imageClicks": 1,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 17.33
      },
      {
        "handle": "travis-michael-x-lonely-floater-family-business-mens-athletic-long-shorts",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 43.87
      },
      {
        "handle": "travis-michael-x-lonely-floater-family-business-unisex-hoodie",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "travis-michael-x-lonely-floater-punky-family-business-dad-hat",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.78
      },
      {
        "handle": "unisex-track-pants",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 20.89
      },
      {
        "handle": "vision-quest-dad-hat-out-for-the-season",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 45.3
      },
      {
        "handle": "vision-quest-unisex-hoodie",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.53
      },
      {
        "handle": "women-s-i-can-do-bad-by-myself-crop-hoodie",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "womens-creature-of-the-night-long-sleeve-tee",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "world-peace-ltd-long-sleeve-t-shirt",
        "views": 2,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 2,
        "averageEngagementSeconds": 28.88
      },
      {
        "handle": "all-love-social-club-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 29.48
      },
      {
        "handle": "at-your-own-wave-length-knit-beanie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "at-your-own-wavelength-short-sleeve-unisex-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 29.8
      },
      {
        "handle": "aux-mic-foam-trucker-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 12.8
      },
      {
        "handle": "aux-mic-trucker-cap",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 7.17
      },
      {
        "handle": "aveek-toxic-by-nature-distressed-denim-bucket-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 56.98
      },
      {
        "handle": "aveek-toxic-by-nature-short-sleeve-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 33.98
      },
      {
        "handle": "aveek-toxic-by-nature-unisex-athletic-long-shorts",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.8
      },
      {
        "handle": "aveek-toxic-by-nature-unisex-heavy-blend-zip-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "aveek-toxic-by-nature-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 32.55
      },
      {
        "handle": "aveek-toxic-by-nature-women-s-heavyweight-boxy-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.89
      },
      {
        "handle": "big-homie-lo-snapback",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 13.78
      },
      {
        "handle": "blu-and-org-backpack",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 7.31
      },
      {
        "handle": "blue-camo-floater-bubble-free-stickers",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "blue-ellis-dad-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 1.7
      },
      {
        "handle": "bolo-youth-short-sleeve-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "bread-winner-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.04
      },
      {
        "handle": "cloud-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 32.32
      },
      {
        "handle": "copy-of-fs-gen2-dnm",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 13.45
      },
      {
        "handle": "copy-of-ultra-cotton-long-sleeve-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "cuffed-beanie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 12.59
      },
      {
        "handle": "diversity-hires-black-and-white-glossy-mug",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.59
      },
      {
        "handle": "dolo-lmnt-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.32
      },
      {
        "handle": "earth-duffy",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 11
      },
      {
        "handle": "earth-men-s-slides",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.78
      },
      {
        "handle": "earth-sports-leggings",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.54
      },
      {
        "handle": "earth-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "earth-women-s-cropped-windbreaker",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 8.51
      },
      {
        "handle": "ellis-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 33.47
      },
      {
        "handle": "ellis-laced-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 32.14
      },
      {
        "handle": "fishscale-floata-tote-bag",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 5.48
      },
      {
        "handle": "float-cuffed-beanie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.75
      },
      {
        "handle": "float-old-school-bucket-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 5.23
      },
      {
        "handle": "floater-crop-top",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.8
      },
      {
        "handle": "floater-unisex-joggers",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "fly-at-your-own-alt-long-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.12
      },
      {
        "handle": "fly-at-your-own-altitude-t",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.64
      },
      {
        "handle": "fly-at-your-own-altitude-unisex-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 34.33
      },
      {
        "handle": "forgotten-secret-white-seam-gris-beanie-out-for-the-season",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 0.99
      },
      {
        "handle": "fs-2020-youth-baseball-cap",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "fs-bucket-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "fs-embroidered-sweatshirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 8.05
      },
      {
        "handle": "fs-wave-unisex-sweatshirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 1.5
      },
      {
        "handle": "goldie-tank-top",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 29
      },
      {
        "handle": "gray-duffy",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "introvert-duffy",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.51
      },
      {
        "handle": "k-o-t-a-unisex-zip-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "king-of-the-autumn-unisex-premium-sweatshirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.71
      },
      {
        "handle": "kkam-moon-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 32.01
      },
      {
        "handle": "lamont-gen2",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "leather-charm-friendship-bracelets-bangles-feather-accessories-wedding-jewelry",
        "views": 1,
        "clicks": 1,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 17
      },
      {
        "handle": "lf-tm-unisex-tank-top",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.92
      },
      {
        "handle": "lfx-leather-bomber-jacket",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 5.08
      },
      {
        "handle": "lfxnyc-embroidered-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.11
      },
      {
        "handle": "lfxnyc-organic-ribbed-beanie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "lfxnyc-women-s-crop-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "lil-homie-lo-youth-baseball-cap",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "loboy-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.84
      },
      {
        "handle": "lonely-floater-gift-card",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.72
      },
      {
        "handle": "lonely-floater-lux-sweatpants",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 11.9
      },
      {
        "handle": "lonely-floater-sponsorship-t",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "lonely-floater-x-travis-michael-socks",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "mens-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 14.66
      },
      {
        "handle": "mens-varsity-jacket",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "mkga-make-kanye-great-again-snapback",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.39
      },
      {
        "handle": "mr-smiley-long-sleeve-1",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 27.94
      },
      {
        "handle": "not-a-day-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 33.37
      },
      {
        "handle": "old-schoo",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "ph-balance-embroidered-champion-packable-jacket",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 27.87
      },
      {
        "handle": "ph-balance-mens-champion-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "pkaac-maga",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "prestige-dad-out-for-the-season",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 3.94
      },
      {
        "handle": "raw-foam-trucker-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.23
      },
      {
        "handle": "sdubd-heavyweight-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 28.5
      },
      {
        "handle": "sdubd-mens-heavyweight-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.52
      },
      {
        "handle": "short-sleeve-unisex-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 32.41
      },
      {
        "handle": "short-sleeve-unisex-t-shirt-2",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.49
      },
      {
        "handle": "skeye",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 32.57
      },
      {
        "handle": "slime-short-sleeve-unisex-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.96
      },
      {
        "handle": "still-humvn-jersey",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 5.05
      },
      {
        "handle": "test-cotton-cap",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.01
      },
      {
        "handle": "the-lfx-coast-2-coast-cuffed-beanie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.1
      },
      {
        "handle": "thunda-snapback-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 26.78
      },
      {
        "handle": "travel-bug-five-panel-cap",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "travel-bugs-unisex-fleece-pullover",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.68
      },
      {
        "handle": "travel-bugs-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.92
      },
      {
        "handle": "travis-michael-x-lonely-floater-family-business-crop-hoodie-1",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.93
      },
      {
        "handle": "tropicamo-floater-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 31.09
      },
      {
        "handle": "trucker-cap-1",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "ultra-cotton-long-sleeve-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 1.67
      },
      {
        "handle": "vanta-fs-dad-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "vision-quest-recycled-tracksuit-jacket",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.51
      },
      {
        "handle": "vision-quest-threaded-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.8
      },
      {
        "handle": "vision-quest-white-seam-granate-beanie-out-for-the-season",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      },
      {
        "handle": "vision-quest-white-seam-oscuro-beanie-out-for-the-season",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.61
      },
      {
        "handle": "vq-lamont-mens-champion-t-shirt",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 29.68
      },
      {
        "handle": "wht-lmnt-3-0",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.44
      },
      {
        "handle": "women-s-wylde-wolf-crop-tee",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 15.44
      },
      {
        "handle": "womens-ego-death-blk",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 8.57
      },
      {
        "handle": "womens-fs-sports-bra",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30.2
      },
      {
        "handle": "world-peace-dad-hat",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 8.43
      },
      {
        "handle": "world-peace-unisex-hoodie",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 30
      },
      {
        "handle": "yellow-badge-bubble-free-stickers",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 25.84
      },
      {
        "handle": "yute-backpack",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 4.59
      },
      {
        "handle": "yute-bikini",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 28.1
      },
      {
        "handle": "yute-crop-top",
        "views": 1,
        "clicks": 0,
        "imageClicks": 0,
        "cartInteractions": 0,
        "checkoutInteractions": 0,
        "purchaseIntent": 0,
        "productPageSessions": 1,
        "averageEngagementSeconds": 2.5
      }
    ],
    "shopifyHumanLandings": {
      "source": "Connected Shopify Analytics — human landing-page sessions",
      "updatedAt": "2026-10-02T18:54:09.402Z",
      "window": {
        "start": "2026-09-11",
        "end": "2026-10-02"
      },
      "scope": "product landing pages only; not all product-page views",
      "complete": true,
      "products": [
        {
          "handle": "for-tee",
          "sessions": 5
        },
        {
          "handle": "fs-crop-sweatshirt",
          "sessions": 3
        },
        {
          "handle": "long-sleeve-t-shirt",
          "sessions": 3
        },
        {
          "handle": "vision-quest-unisex-fleece-sweatpants",
          "sessions": 3
        },
        {
          "handle": "dressy-sweats",
          "sessions": 3
        },
        {
          "handle": "dream-big-unisex-t-shirt",
          "sessions": 3
        },
        {
          "handle": "new-bolo",
          "sessions": 3
        },
        {
          "handle": "travis-michael-x-lonely-floater-family-business-unisex-hoodie",
          "sessions": 3
        },
        {
          "handle": "lfx-ello-beanie",
          "sessions": 3
        },
        {
          "handle": "womens-focus-bear-hoodie",
          "sessions": 2
        },
        {
          "handle": "fire-red-t-shirt",
          "sessions": 2
        },
        {
          "handle": "vision-quest-dad-hat-out-for-the-season",
          "sessions": 2
        },
        {
          "handle": "fs-laced-hoodie",
          "sessions": 2
        },
        {
          "handle": "mkga-make-kanye-great-again-fitted",
          "sessions": 2
        },
        {
          "handle": "womens-creature-of-the-night-long-sleeve-tee",
          "sessions": 2
        },
        {
          "handle": "fs-embroidered-t-shirt",
          "sessions": 2
        },
        {
          "handle": "balance-sweatshirt",
          "sessions": 2
        },
        {
          "handle": "baby-frosty-tee",
          "sessions": 2
        },
        {
          "handle": "aveek-toxic-by-nature-crop-hoodie",
          "sessions": 2
        },
        {
          "handle": "allevil-short-sleeve-unisex-t-shirt",
          "sessions": 2
        },
        {
          "handle": "aveek-toxic-by-nature-women-s-heavyweight-boxy-tee",
          "sessions": 1
        },
        {
          "handle": "island-floater-dad-hat",
          "sessions": 1
        },
        {
          "handle": "womens-tropicamo-crop-hoodie",
          "sessions": 1
        },
        {
          "handle": "at-your-own-wavelength-short-sleeve-unisex-t-shirt",
          "sessions": 1
        },
        {
          "handle": "fs-no-lace-unisex-hoodie",
          "sessions": 1
        },
        {
          "handle": "travis-michael-x-lonely-floater-family-business-mens-athletic-long-shorts",
          "sessions": 1
        },
        {
          "handle": "skeye",
          "sessions": 1
        },
        {
          "handle": "wht-lmnt-3-0",
          "sessions": 1
        },
        {
          "handle": "classic-lonely-floater-hoodie",
          "sessions": 1
        },
        {
          "handle": "shine-bright-tee-unisex-long-sleeve-tee",
          "sessions": 1
        },
        {
          "handle": "lfxnyc-embroidered-t-shirt",
          "sessions": 1
        },
        {
          "handle": "pink-sig",
          "sessions": 1
        },
        {
          "handle": "float-cuffed-beanie",
          "sessions": 1
        },
        {
          "handle": "short-sleeve-unisex-t-shirt-2",
          "sessions": 1
        },
        {
          "handle": "lf-embroidered-champion-backpack",
          "sessions": 1
        },
        {
          "handle": "floater-crop-top",
          "sessions": 1
        },
        {
          "handle": "lonely-floater-x-travis-michael-socks",
          "sessions": 1
        },
        {
          "handle": "old-float-orange-school-bucket-hat",
          "sessions": 1
        },
        {
          "handle": "mens-varsity-jacket",
          "sessions": 1
        },
        {
          "handle": "lamont-bucket-hat",
          "sessions": 1
        },
        {
          "handle": "tropicamo-floater-unisex-hoodie",
          "sessions": 1
        },
        {
          "handle": "earth-men-s-slides",
          "sessions": 1
        },
        {
          "handle": "lonely-floater-x-travis-michael-duffle-bag",
          "sessions": 1
        },
        {
          "handle": "ph-balance-embroidered-champion-packable-jacket",
          "sessions": 1
        },
        {
          "handle": "vision-quest-hoodie",
          "sessions": 1
        },
        {
          "handle": "travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie",
          "sessions": 1
        },
        {
          "handle": "sdubd-heavyweight-tee",
          "sessions": 1
        },
        {
          "handle": "test-cotton-cap",
          "sessions": 1
        },
        {
          "handle": "world-peace-ltd-long-sleeve-t-shirt",
          "sessions": 1
        },
        {
          "handle": "lff-long-sleeve-fitted-crew-gym-shirt",
          "sessions": 1
        },
        {
          "handle": "lamont-gen2",
          "sessions": 1
        },
        {
          "handle": "tropicamo-mens-athletic-long-shorts",
          "sessions": 1
        },
        {
          "handle": "aveek-avm-under-armour-backpack-1",
          "sessions": 1
        },
        {
          "handle": "mkga-make-kanye-great-again-snapback",
          "sessions": 1
        },
        {
          "handle": "dolo-lmnt-hoodie",
          "sessions": 1
        },
        {
          "handle": "yute-backpack",
          "sessions": 1
        },
        {
          "handle": "fly-at-your-own-altitude-t",
          "sessions": 1
        },
        {
          "handle": "fs-2020-youth-baseball-cap",
          "sessions": 1
        },
        {
          "handle": "vision-quest-recycled-tracksuit-jacket",
          "sessions": 1
        },
        {
          "handle": "lonely-floater-gift-card",
          "sessions": 1
        },
        {
          "handle": "lonely-floater-lux-hoodie",
          "sessions": 1
        },
        {
          "handle": "travel-bugs-unisex-fleece-sweatpants",
          "sessions": 1
        },
        {
          "handle": "copy-of-infant-fine-jersey-bodysuit",
          "sessions": 1
        },
        {
          "handle": "aveek-toxic-by-nature-unisex-athletic-long-shorts",
          "sessions": 1
        },
        {
          "handle": "vq-lamont-mens-champion-t-shirt",
          "sessions": 1
        },
        {
          "handle": "limited-edition-skate-tee-long-sleeve-tee",
          "sessions": 1
        },
        {
          "handle": "bread-winner-tee",
          "sessions": 1
        },
        {
          "handle": "lfxnyc-women-s-crop-tee",
          "sessions": 1
        },
        {
          "handle": "all-love-social-club-unisex-hoodie",
          "sessions": 1
        },
        {
          "handle": "travis-michael-x-lonely-floater-punky-family-business-dad-hat",
          "sessions": 1
        },
        {
          "handle": "kid-robot-infant-fine-jersey-bodysuit",
          "sessions": 1
        }
      ]
    }
  },
  "productPolicy": {
    "supplierOnly": true,
    "updatedAt": "2026-10-02T19:11:21.250Z",
    "excludedCollections": [
      "first-flight-saga"
    ],
    "excludedHandles": [
      "copy-of-fs-gen2-blk-1",
      "copy-of-fs-gen2-blk",
      "copy-of-fs-gen2-blk-2",
      "still-humvn-jersey",
      "fs-gen2-blk",
      "floater-jersey",
      "lfxnyc-sticker-pack"
    ],
    "confirmedSupplierFulfilledHandles": [
      "fs23-dad-hat",
      "fs23-ribbed-knit-beanie",
      "dad-hat-2",
      "aveek-toxic-by-nature-short-sleeve-t-shirt",
      "aveek-toxic-by-nature-crop-hoodie",
      "aveek-toxic-by-nature-women-s-heavyweight-boxy-tee",
      "travis-michael-x-lonely-floater-punky-family-business-dad-hat",
      "dad-hat-1",
      "travis-michael-x-lonely-floater-family-business-unisex-hoodie",
      "travis-michael-x-lonely-floater-family-business-camo-splash-unisex-hoodie",
      "the-lfx-coast-2-coast-cuffed-beanie",
      "earth-print-bandana",
      "lonely-floater-lunar-return-dad-hat",
      "forgotten-vision-bucket",
      "coast-2-coast-trucker",
      "travel-bugs-unisex-fleece-sweatpants",
      "for-tee",
      "fs-embroidered-t-shirt",
      "vision-quest-unisex-fleece-sweatpants",
      "lonely-floater-x-travis-michael-duffle-bag",
      "dream-big-unisex-t-shirt",
      "balance-sweatshirt",
      "lonely-floater-lux-hoodie",
      "fire-red-t-shirt",
      "womens-focus-bear-hoodie",
      "allevil-short-sleeve-unisex-t-shirt",
      "long-sleeve-t-shirt",
      "fly-at-your-own-altitude-premium-heavyweight-tee",
      "womens-tropicamo-crop-hoodie",
      "dressy-sweats",
      "2-angels-in-the-sky-tee",
      "fs-embroidered-sweatshirt",
      "limited-edition-skate-tee-long-sleeve-tee",
      "travis-kanji-t-shirt",
      "fly-at-your-own-alt-long-tee",
      "vision-quest-unisex-hoodie",
      "shine-bright-tee-unisex-long-sleeve-tee",
      "king-of-the-autumn-unisex-premium-sweatshirt"
    ]
  },
  "twoYearRanking": {
    "source": "Connected Shopify Analytics ShopifyQL: human product landing-page sessions",
    "updatedAt": "2026-10-02T19:11:21.250Z",
    "window": {
      "start": "2024-10-02",
      "end": "2026-10-02"
    },
    "metric": "human sessions starting on a product page",
    "coverage": {
      "queryRows": 1000,
      "queryLimit": 1000,
      "queryCapped": true,
      "note": "Top landing-page rows were sorted by sessions; this is not a complete page-view report."
    },
    "maxProducts": 7,
    "maxAgeDays": 90,
    "caption": "The pieces in rotation right now. Available while they last.",
    "products": [
      {
        "handle": "2-angels-in-the-sky-tee",
        "sessions": 1970
      },
      {
        "handle": "dream-big-unisex-t-shirt",
        "sessions": 1651
      },
      {
        "handle": "fs-embroidered-sweatshirt",
        "sessions": 1516
      },
      {
        "handle": "limited-edition-skate-tee-long-sleeve-tee",
        "sessions": 1231
      },
      {
        "handle": "fs-embroidered-t-shirt",
        "sessions": 1196
      },
      {
        "handle": "fly-at-your-own-altitude-premium-heavyweight-tee",
        "sessions": 1118
      },
      {
        "handle": "travis-kanji-t-shirt",
        "sessions": 1066
      },
      {
        "handle": "fly-at-your-own-alt-long-tee",
        "sessions": 976
      },
      {
        "handle": "vision-quest-unisex-hoodie",
        "sessions": 948
      },
      {
        "handle": "lonely-floater-lux-hoodie",
        "sessions": 781
      },
      {
        "handle": "shine-bright-tee-unisex-long-sleeve-tee",
        "sessions": 606
      },
      {
        "handle": "king-of-the-autumn-unisex-premium-sweatshirt",
        "sessions": 513
      }
    ],
    "featuredSeventhHandle": "vision-quest-unisex-hoodie"
  }
};
